<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-input
            v-model="search"
            prepend-icon="fas fa-search"
            placeholder="Filtrar ícones..."
            size="sm"
          />
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row class="justify-content-center">
        <b-col lg="10">
          <card header-classes="bg-transparent">
            <h3 slot="header" class="mb-0">
              Nucleo Icons
              <small class="text-muted">({{ filteredNi.length }})</small>
            </h3>
            <b-row class="icon-examples">
              <b-col
                v-for="name in filteredNi"
                :key="'ni-' + name"
                lg="3"
                md="6"
              >
                <button
                  type="button"
                  class="btn-icon-clipboard"
                  v-clipboard:copy="'ni ' + name"
                  v-clipboard:success="onCopy"
                  title="Copy to clipboard"
                >
                  <div>
                    <i :class="'ni ' + name"></i>
                    <span>{{ name }}</span>
                  </div>
                </button>
              </b-col>
            </b-row>
          </card>

          <card header-classes="bg-transparent" class="mt-4">
            <h3 slot="header" class="mb-0">
              Nucleo Outline (no)
              <small class="text-muted">({{ filteredNo.length }})</small>
            </h3>
            <b-row class="icon-examples">
              <b-col
                v-for="name in filteredNo"
                :key="'no-' + name"
                lg="3"
                md="6"
              >
                <button
                  type="button"
                  class="btn-icon-clipboard"
                  v-clipboard:copy="'no ' + name"
                  v-clipboard:success="onCopy"
                  title="Copy to clipboard"
                >
                  <div>
                    <i :class="'no ' + name"></i>
                    <span>{{ name }}</span>
                  </div>
                </button>
              </b-col>
            </b-row>
          </card>

          <card header-classes="bg-transparent" class="mt-4">
            <h3 slot="header" class="mb-0">
              Font Awesome 5
              <small class="text-muted">({{ filteredFa.length }})</small>
            </h3>
            <b-row class="icon-examples">
              <b-col
                v-for="icon in filteredFa"
                :key="icon.className"
                lg="3"
                md="6"
              >
                <button
                  type="button"
                  class="btn-icon-clipboard"
                  v-clipboard:copy="icon.className"
                  v-clipboard:success="onCopy"
                  title="Copy to clipboard"
                >
                  <div>
                    <i :class="icon.className"></i>
                    <span>{{ icon.className }}</span>
                  </div>
                </button>
              </b-col>
            </b-row>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import RouteBreadcrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import BaseHeader from '@/components/BaseHeader'

Vue.use(VueClipboard)

const NI_ICONS = [
  "ni-active-40",
  "ni-air-baloon",
  "ni-album-2",
  "ni-align-center",
  "ni-align-left-2",
  "ni-ambulance",
  "ni-app",
  "ni-archive-2",
  "ni-atom",
  "ni-badge",
  "ni-bag-17",
  "ni-basket",
  "ni-bell-55",
  "ni-bold",
  "ni-bold-down",
  "ni-bold-left",
  "ni-bold-right",
  "ni-bold-up",
  "ni-book-bookmark",
  "ni-books",
  "ni-box-2",
  "ni-briefcase-24",
  "ni-building",
  "ni-bulb-61",
  "ni-bullet-list-67",
  "ni-bus-front-12",
  "ni-button-pause",
  "ni-button-play",
  "ni-button-power",
  "ni-calendar-grid-58",
  "ni-camera-compact",
  "ni-caps-small",
  "ni-cart",
  "ni-chart-bar-32",
  "ni-chart-pie-35",
  "ni-chat-round",
  "ni-check-bold",
  "ni-circle-08",
  "ni-cloud-download-95",
  "ni-cloud-upload-96",
  "ni-collection",
  "ni-compass-04",
  "ni-controller",
  "ni-credit-card",
  "ni-curved-next",
  "ni-delivery-fast",
  "ni-diamond",
  "ni-email-83",
  "ni-fat-add",
  "ni-fat-delete",
  "ni-fat-remove",
  "ni-favourite-28",
  "ni-folder-17",
  "ni-glasses-2",
  "ni-hat-3",
  "ni-headphones",
  "ni-html5",
  "ni-image",
  "ni-istanbul",
  "ni-key-25",
  "ni-laptop",
  "ni-like-2",
  "ni-lock-circle-open",
  "ni-map-big",
  "ni-mobile-button",
  "ni-money-coins",
  "ni-note-03",
  "ni-notification-70",
  "ni-palette",
  "ni-paper-diploma",
  "ni-pin-3",
  "ni-planet",
  "ni-ruler-pencil",
  "ni-satisfied",
  "ni-scissors",
  "ni-send",
  "ni-settings",
  "ni-settings-gear-65",
  "ni-shop",
  "ni-single-02",
  "ni-single-copy-04",
  "ni-sound-wave",
  "ni-spaceship",
  "ni-square-pin",
  "ni-support-16",
  "ni-tablet-button",
  "ni-tag",
  "ni-tie-bow",
  "ni-time-alarm",
  "ni-trophy",
  "ni-tv-2",
  "ni-ui-04",
  "ni-umbrella-13",
  "ni-ungroup",
  "ni-user-run",
  "ni-vector",
  "ni-watch-time",
  "ni-world",
  "ni-world-2",
  "ni-zoom-split-in"
]

const NO_ICONS = [
  "no-alarm",
  "no-attachment-2",
  "no-bookmark",
  "no-c-check",
  "no-c-info",
  "no-c-question-3",
  "no-c-remove-2",
  "no-c-warning",
  "no-calendar",
  "no-calendar-3",
  "no-check",
  "no-check-bold",
  "no-check-double-2",
  "no-circle-arrow-down",
  "no-circle-arrow-down-3",
  "no-circle-arrow-right",
  "no-circle-arrow-right-3",
  "no-cogwheel",
  "no-cogwheel-3",
  "no-control-panel",
  "no-data-download",
  "no-database",
  "no-down-arrow",
  "no-drop-3",
  "no-e-add",
  "no-e-remove",
  "no-edit",
  "no-file-text-3",
  "no-floppy-disk",
  "no-graduation-cap",
  "no-grid-interface",
  "no-home-3",
  "no-house-6",
  "no-image",
  "no-image-mountain",
  "no-info",
  "no-instagram",
  "no-launch",
  "no-left-arrow",
  "no-link",
  "no-lock",
  "no-mail",
  "no-megaphone",
  "no-menu-8",
  "no-pin-tack",
  "no-pin-tack-2",
  "no-plus",
  "no-position-marker",
  "no-present-3",
  "no-profile-3",
  "no-right-arrow",
  "no-right-arrow-2",
  "no-right-arrow-3",
  "no-right-arrow-4",
  "no-right-arrow-5",
  "no-shopping-cart",
  "no-skull",
  "no-stack",
  "no-star",
  "no-switches",
  "no-time-alarm",
  "no-toggle",
  "no-translation-3",
  "no-trash",
  "no-unlink",
  "no-unordered-list",
  "no-up-arrow",
  "no-user",
  "no-users",
  "no-view",
  "no-watering-plants",
  "no-whatsapp"
]

const FA_ICONS = [
  {
    "name": "500px",
    "prefix": "fab",
    "className": "fab fa-500px"
  },
  {
    "name": "accessible-icon",
    "prefix": "fab",
    "className": "fab fa-accessible-icon"
  },
  {
    "name": "accusoft",
    "prefix": "fab",
    "className": "fab fa-accusoft"
  },
  {
    "name": "acquisitions-incorporated",
    "prefix": "fab",
    "className": "fab fa-acquisitions-incorporated"
  },
  {
    "name": "ad",
    "prefix": "fas",
    "className": "fas fa-ad"
  },
  {
    "name": "address-book",
    "prefix": "fas",
    "className": "fas fa-address-book"
  },
  {
    "name": "address-card",
    "prefix": "fas",
    "className": "fas fa-address-card"
  },
  {
    "name": "adjust",
    "prefix": "fas",
    "className": "fas fa-adjust"
  },
  {
    "name": "adn",
    "prefix": "fab",
    "className": "fab fa-adn"
  },
  {
    "name": "adobe",
    "prefix": "fab",
    "className": "fab fa-adobe"
  },
  {
    "name": "adversal",
    "prefix": "fab",
    "className": "fab fa-adversal"
  },
  {
    "name": "affiliatetheme",
    "prefix": "fab",
    "className": "fab fa-affiliatetheme"
  },
  {
    "name": "air-freshener",
    "prefix": "fas",
    "className": "fas fa-air-freshener"
  },
  {
    "name": "algolia",
    "prefix": "fab",
    "className": "fab fa-algolia"
  },
  {
    "name": "align-center",
    "prefix": "fas",
    "className": "fas fa-align-center"
  },
  {
    "name": "align-justify",
    "prefix": "fas",
    "className": "fas fa-align-justify"
  },
  {
    "name": "align-left",
    "prefix": "fas",
    "className": "fas fa-align-left"
  },
  {
    "name": "align-right",
    "prefix": "fas",
    "className": "fas fa-align-right"
  },
  {
    "name": "alipay",
    "prefix": "fab",
    "className": "fab fa-alipay"
  },
  {
    "name": "allergies",
    "prefix": "fas",
    "className": "fas fa-allergies"
  },
  {
    "name": "amazon",
    "prefix": "fab",
    "className": "fab fa-amazon"
  },
  {
    "name": "amazon-pay",
    "prefix": "fab",
    "className": "fab fa-amazon-pay"
  },
  {
    "name": "ambulance",
    "prefix": "fas",
    "className": "fas fa-ambulance"
  },
  {
    "name": "american-sign-language-interpreting",
    "prefix": "fas",
    "className": "fas fa-american-sign-language-interpreting"
  },
  {
    "name": "amilia",
    "prefix": "fab",
    "className": "fab fa-amilia"
  },
  {
    "name": "anchor",
    "prefix": "fas",
    "className": "fas fa-anchor"
  },
  {
    "name": "android",
    "prefix": "fab",
    "className": "fab fa-android"
  },
  {
    "name": "angellist",
    "prefix": "fab",
    "className": "fab fa-angellist"
  },
  {
    "name": "angle-double-down",
    "prefix": "fas",
    "className": "fas fa-angle-double-down"
  },
  {
    "name": "angle-double-left",
    "prefix": "fas",
    "className": "fas fa-angle-double-left"
  },
  {
    "name": "angle-double-right",
    "prefix": "fas",
    "className": "fas fa-angle-double-right"
  },
  {
    "name": "angle-double-up",
    "prefix": "fas",
    "className": "fas fa-angle-double-up"
  },
  {
    "name": "angle-down",
    "prefix": "fas",
    "className": "fas fa-angle-down"
  },
  {
    "name": "angle-left",
    "prefix": "fas",
    "className": "fas fa-angle-left"
  },
  {
    "name": "angle-right",
    "prefix": "fas",
    "className": "fas fa-angle-right"
  },
  {
    "name": "angle-up",
    "prefix": "fas",
    "className": "fas fa-angle-up"
  },
  {
    "name": "angry",
    "prefix": "fas",
    "className": "fas fa-angry"
  },
  {
    "name": "angrycreative",
    "prefix": "fab",
    "className": "fab fa-angrycreative"
  },
  {
    "name": "angular",
    "prefix": "fab",
    "className": "fab fa-angular"
  },
  {
    "name": "ankh",
    "prefix": "fas",
    "className": "fas fa-ankh"
  },
  {
    "name": "app-store",
    "prefix": "fab",
    "className": "fab fa-app-store"
  },
  {
    "name": "app-store-ios",
    "prefix": "fab",
    "className": "fab fa-app-store-ios"
  },
  {
    "name": "apper",
    "prefix": "fab",
    "className": "fab fa-apper"
  },
  {
    "name": "apple",
    "prefix": "fab",
    "className": "fab fa-apple"
  },
  {
    "name": "apple-alt",
    "prefix": "fas",
    "className": "fas fa-apple-alt"
  },
  {
    "name": "apple-pay",
    "prefix": "fab",
    "className": "fab fa-apple-pay"
  },
  {
    "name": "archive",
    "prefix": "fas",
    "className": "fas fa-archive"
  },
  {
    "name": "archway",
    "prefix": "fas",
    "className": "fas fa-archway"
  },
  {
    "name": "arrow-alt-circle-down",
    "prefix": "fas",
    "className": "fas fa-arrow-alt-circle-down"
  },
  {
    "name": "arrow-alt-circle-left",
    "prefix": "fas",
    "className": "fas fa-arrow-alt-circle-left"
  },
  {
    "name": "arrow-alt-circle-right",
    "prefix": "fas",
    "className": "fas fa-arrow-alt-circle-right"
  },
  {
    "name": "arrow-alt-circle-up",
    "prefix": "fas",
    "className": "fas fa-arrow-alt-circle-up"
  },
  {
    "name": "arrow-circle-down",
    "prefix": "fas",
    "className": "fas fa-arrow-circle-down"
  },
  {
    "name": "arrow-circle-left",
    "prefix": "fas",
    "className": "fas fa-arrow-circle-left"
  },
  {
    "name": "arrow-circle-right",
    "prefix": "fas",
    "className": "fas fa-arrow-circle-right"
  },
  {
    "name": "arrow-circle-up",
    "prefix": "fas",
    "className": "fas fa-arrow-circle-up"
  },
  {
    "name": "arrow-down",
    "prefix": "fas",
    "className": "fas fa-arrow-down"
  },
  {
    "name": "arrow-left",
    "prefix": "fas",
    "className": "fas fa-arrow-left"
  },
  {
    "name": "arrow-right",
    "prefix": "fas",
    "className": "fas fa-arrow-right"
  },
  {
    "name": "arrow-up",
    "prefix": "fas",
    "className": "fas fa-arrow-up"
  },
  {
    "name": "arrows-alt",
    "prefix": "fas",
    "className": "fas fa-arrows-alt"
  },
  {
    "name": "arrows-alt-h",
    "prefix": "fas",
    "className": "fas fa-arrows-alt-h"
  },
  {
    "name": "arrows-alt-v",
    "prefix": "fas",
    "className": "fas fa-arrows-alt-v"
  },
  {
    "name": "artstation",
    "prefix": "fab",
    "className": "fab fa-artstation"
  },
  {
    "name": "assistive-listening-systems",
    "prefix": "fas",
    "className": "fas fa-assistive-listening-systems"
  },
  {
    "name": "asterisk",
    "prefix": "fas",
    "className": "fas fa-asterisk"
  },
  {
    "name": "asymmetrik",
    "prefix": "fab",
    "className": "fab fa-asymmetrik"
  },
  {
    "name": "at",
    "prefix": "fas",
    "className": "fas fa-at"
  },
  {
    "name": "atlas",
    "prefix": "fas",
    "className": "fas fa-atlas"
  },
  {
    "name": "atlassian",
    "prefix": "fab",
    "className": "fab fa-atlassian"
  },
  {
    "name": "atom",
    "prefix": "fas",
    "className": "fas fa-atom"
  },
  {
    "name": "audible",
    "prefix": "fab",
    "className": "fab fa-audible"
  },
  {
    "name": "audio-description",
    "prefix": "fas",
    "className": "fas fa-audio-description"
  },
  {
    "name": "autoprefixer",
    "prefix": "fab",
    "className": "fab fa-autoprefixer"
  },
  {
    "name": "avianex",
    "prefix": "fab",
    "className": "fab fa-avianex"
  },
  {
    "name": "aviato",
    "prefix": "fab",
    "className": "fab fa-aviato"
  },
  {
    "name": "award",
    "prefix": "fas",
    "className": "fas fa-award"
  },
  {
    "name": "aws",
    "prefix": "fab",
    "className": "fab fa-aws"
  },
  {
    "name": "baby",
    "prefix": "fas",
    "className": "fas fa-baby"
  },
  {
    "name": "baby-carriage",
    "prefix": "fas",
    "className": "fas fa-baby-carriage"
  },
  {
    "name": "backspace",
    "prefix": "fas",
    "className": "fas fa-backspace"
  },
  {
    "name": "backward",
    "prefix": "fas",
    "className": "fas fa-backward"
  },
  {
    "name": "balance-scale",
    "prefix": "fas",
    "className": "fas fa-balance-scale"
  },
  {
    "name": "ban",
    "prefix": "fas",
    "className": "fas fa-ban"
  },
  {
    "name": "band-aid",
    "prefix": "fas",
    "className": "fas fa-band-aid"
  },
  {
    "name": "bandcamp",
    "prefix": "fab",
    "className": "fab fa-bandcamp"
  },
  {
    "name": "barcode",
    "prefix": "fas",
    "className": "fas fa-barcode"
  },
  {
    "name": "bars",
    "prefix": "fas",
    "className": "fas fa-bars"
  },
  {
    "name": "baseball-ball",
    "prefix": "fas",
    "className": "fas fa-baseball-ball"
  },
  {
    "name": "basketball-ball",
    "prefix": "fas",
    "className": "fas fa-basketball-ball"
  },
  {
    "name": "bath",
    "prefix": "fas",
    "className": "fas fa-bath"
  },
  {
    "name": "battery-empty",
    "prefix": "fas",
    "className": "fas fa-battery-empty"
  },
  {
    "name": "battery-full",
    "prefix": "fas",
    "className": "fas fa-battery-full"
  },
  {
    "name": "battery-half",
    "prefix": "fas",
    "className": "fas fa-battery-half"
  },
  {
    "name": "battery-quarter",
    "prefix": "fas",
    "className": "fas fa-battery-quarter"
  },
  {
    "name": "battery-three-quarters",
    "prefix": "fas",
    "className": "fas fa-battery-three-quarters"
  },
  {
    "name": "bed",
    "prefix": "fas",
    "className": "fas fa-bed"
  },
  {
    "name": "beer",
    "prefix": "fas",
    "className": "fas fa-beer"
  },
  {
    "name": "behance",
    "prefix": "fab",
    "className": "fab fa-behance"
  },
  {
    "name": "behance-square",
    "prefix": "fab",
    "className": "fab fa-behance-square"
  },
  {
    "name": "bell",
    "prefix": "fas",
    "className": "fas fa-bell"
  },
  {
    "name": "bell-slash",
    "prefix": "fas",
    "className": "fas fa-bell-slash"
  },
  {
    "name": "bezier-curve",
    "prefix": "fas",
    "className": "fas fa-bezier-curve"
  },
  {
    "name": "bible",
    "prefix": "fas",
    "className": "fas fa-bible"
  },
  {
    "name": "bicycle",
    "prefix": "fas",
    "className": "fas fa-bicycle"
  },
  {
    "name": "bimobject",
    "prefix": "fab",
    "className": "fab fa-bimobject"
  },
  {
    "name": "binoculars",
    "prefix": "fas",
    "className": "fas fa-binoculars"
  },
  {
    "name": "biohazard",
    "prefix": "fas",
    "className": "fas fa-biohazard"
  },
  {
    "name": "birthday-cake",
    "prefix": "fas",
    "className": "fas fa-birthday-cake"
  },
  {
    "name": "bitbucket",
    "prefix": "fab",
    "className": "fab fa-bitbucket"
  },
  {
    "name": "bitcoin",
    "prefix": "fab",
    "className": "fab fa-bitcoin"
  },
  {
    "name": "bity",
    "prefix": "fab",
    "className": "fab fa-bity"
  },
  {
    "name": "black-tie",
    "prefix": "fab",
    "className": "fab fa-black-tie"
  },
  {
    "name": "blackberry",
    "prefix": "fab",
    "className": "fab fa-blackberry"
  },
  {
    "name": "blender",
    "prefix": "fas",
    "className": "fas fa-blender"
  },
  {
    "name": "blender-phone",
    "prefix": "fas",
    "className": "fas fa-blender-phone"
  },
  {
    "name": "blind",
    "prefix": "fas",
    "className": "fas fa-blind"
  },
  {
    "name": "blog",
    "prefix": "fas",
    "className": "fas fa-blog"
  },
  {
    "name": "blogger",
    "prefix": "fab",
    "className": "fab fa-blogger"
  },
  {
    "name": "blogger-b",
    "prefix": "fab",
    "className": "fab fa-blogger-b"
  },
  {
    "name": "bluetooth",
    "prefix": "fab",
    "className": "fab fa-bluetooth"
  },
  {
    "name": "bluetooth-b",
    "prefix": "fab",
    "className": "fab fa-bluetooth-b"
  },
  {
    "name": "bold",
    "prefix": "fas",
    "className": "fas fa-bold"
  },
  {
    "name": "bolt",
    "prefix": "fas",
    "className": "fas fa-bolt"
  },
  {
    "name": "bomb",
    "prefix": "fas",
    "className": "fas fa-bomb"
  },
  {
    "name": "bone",
    "prefix": "fas",
    "className": "fas fa-bone"
  },
  {
    "name": "bong",
    "prefix": "fas",
    "className": "fas fa-bong"
  },
  {
    "name": "book",
    "prefix": "fas",
    "className": "fas fa-book"
  },
  {
    "name": "book-dead",
    "prefix": "fas",
    "className": "fas fa-book-dead"
  },
  {
    "name": "book-open",
    "prefix": "fas",
    "className": "fas fa-book-open"
  },
  {
    "name": "book-reader",
    "prefix": "fas",
    "className": "fas fa-book-reader"
  },
  {
    "name": "bookmark",
    "prefix": "fas",
    "className": "fas fa-bookmark"
  },
  {
    "name": "bowling-ball",
    "prefix": "fas",
    "className": "fas fa-bowling-ball"
  },
  {
    "name": "box",
    "prefix": "fas",
    "className": "fas fa-box"
  },
  {
    "name": "box-open",
    "prefix": "fas",
    "className": "fas fa-box-open"
  },
  {
    "name": "boxes",
    "prefix": "fas",
    "className": "fas fa-boxes"
  },
  {
    "name": "braille",
    "prefix": "fas",
    "className": "fas fa-braille"
  },
  {
    "name": "brain",
    "prefix": "fas",
    "className": "fas fa-brain"
  },
  {
    "name": "briefcase",
    "prefix": "fas",
    "className": "fas fa-briefcase"
  },
  {
    "name": "briefcase-medical",
    "prefix": "fas",
    "className": "fas fa-briefcase-medical"
  },
  {
    "name": "broadcast-tower",
    "prefix": "fas",
    "className": "fas fa-broadcast-tower"
  },
  {
    "name": "broom",
    "prefix": "fas",
    "className": "fas fa-broom"
  },
  {
    "name": "brush",
    "prefix": "fas",
    "className": "fas fa-brush"
  },
  {
    "name": "btc",
    "prefix": "fab",
    "className": "fab fa-btc"
  },
  {
    "name": "bug",
    "prefix": "fas",
    "className": "fas fa-bug"
  },
  {
    "name": "building",
    "prefix": "fas",
    "className": "fas fa-building"
  },
  {
    "name": "bullhorn",
    "prefix": "fas",
    "className": "fas fa-bullhorn"
  },
  {
    "name": "bullseye",
    "prefix": "fas",
    "className": "fas fa-bullseye"
  },
  {
    "name": "burn",
    "prefix": "fas",
    "className": "fas fa-burn"
  },
  {
    "name": "buromobelexperte",
    "prefix": "fab",
    "className": "fab fa-buromobelexperte"
  },
  {
    "name": "bus",
    "prefix": "fas",
    "className": "fas fa-bus"
  },
  {
    "name": "bus-alt",
    "prefix": "fas",
    "className": "fas fa-bus-alt"
  },
  {
    "name": "business-time",
    "prefix": "fas",
    "className": "fas fa-business-time"
  },
  {
    "name": "buysellads",
    "prefix": "fab",
    "className": "fab fa-buysellads"
  },
  {
    "name": "calculator",
    "prefix": "fas",
    "className": "fas fa-calculator"
  },
  {
    "name": "calendar",
    "prefix": "fas",
    "className": "fas fa-calendar"
  },
  {
    "name": "calendar-alt",
    "prefix": "fas",
    "className": "fas fa-calendar-alt"
  },
  {
    "name": "calendar-check",
    "prefix": "fas",
    "className": "fas fa-calendar-check"
  },
  {
    "name": "calendar-day",
    "prefix": "fas",
    "className": "fas fa-calendar-day"
  },
  {
    "name": "calendar-minus",
    "prefix": "fas",
    "className": "fas fa-calendar-minus"
  },
  {
    "name": "calendar-plus",
    "prefix": "fas",
    "className": "fas fa-calendar-plus"
  },
  {
    "name": "calendar-times",
    "prefix": "fas",
    "className": "fas fa-calendar-times"
  },
  {
    "name": "calendar-week",
    "prefix": "fas",
    "className": "fas fa-calendar-week"
  },
  {
    "name": "camera",
    "prefix": "fas",
    "className": "fas fa-camera"
  },
  {
    "name": "camera-retro",
    "prefix": "fas",
    "className": "fas fa-camera-retro"
  },
  {
    "name": "campground",
    "prefix": "fas",
    "className": "fas fa-campground"
  },
  {
    "name": "canadian-maple-leaf",
    "prefix": "fab",
    "className": "fab fa-canadian-maple-leaf"
  },
  {
    "name": "candy-cane",
    "prefix": "fas",
    "className": "fas fa-candy-cane"
  },
  {
    "name": "cannabis",
    "prefix": "fas",
    "className": "fas fa-cannabis"
  },
  {
    "name": "capsules",
    "prefix": "fas",
    "className": "fas fa-capsules"
  },
  {
    "name": "car",
    "prefix": "fas",
    "className": "fas fa-car"
  },
  {
    "name": "car-alt",
    "prefix": "fas",
    "className": "fas fa-car-alt"
  },
  {
    "name": "car-battery",
    "prefix": "fas",
    "className": "fas fa-car-battery"
  },
  {
    "name": "car-crash",
    "prefix": "fas",
    "className": "fas fa-car-crash"
  },
  {
    "name": "car-side",
    "prefix": "fas",
    "className": "fas fa-car-side"
  },
  {
    "name": "caret-down",
    "prefix": "fas",
    "className": "fas fa-caret-down"
  },
  {
    "name": "caret-left",
    "prefix": "fas",
    "className": "fas fa-caret-left"
  },
  {
    "name": "caret-right",
    "prefix": "fas",
    "className": "fas fa-caret-right"
  },
  {
    "name": "caret-square-down",
    "prefix": "fas",
    "className": "fas fa-caret-square-down"
  },
  {
    "name": "caret-square-left",
    "prefix": "fas",
    "className": "fas fa-caret-square-left"
  },
  {
    "name": "caret-square-right",
    "prefix": "fas",
    "className": "fas fa-caret-square-right"
  },
  {
    "name": "caret-square-up",
    "prefix": "fas",
    "className": "fas fa-caret-square-up"
  },
  {
    "name": "caret-up",
    "prefix": "fas",
    "className": "fas fa-caret-up"
  },
  {
    "name": "carrot",
    "prefix": "fas",
    "className": "fas fa-carrot"
  },
  {
    "name": "cart-arrow-down",
    "prefix": "fas",
    "className": "fas fa-cart-arrow-down"
  },
  {
    "name": "cart-plus",
    "prefix": "fas",
    "className": "fas fa-cart-plus"
  },
  {
    "name": "cash-register",
    "prefix": "fas",
    "className": "fas fa-cash-register"
  },
  {
    "name": "cat",
    "prefix": "fas",
    "className": "fas fa-cat"
  },
  {
    "name": "cc-amazon-pay",
    "prefix": "fab",
    "className": "fab fa-cc-amazon-pay"
  },
  {
    "name": "cc-amex",
    "prefix": "fab",
    "className": "fab fa-cc-amex"
  },
  {
    "name": "cc-apple-pay",
    "prefix": "fab",
    "className": "fab fa-cc-apple-pay"
  },
  {
    "name": "cc-diners-club",
    "prefix": "fab",
    "className": "fab fa-cc-diners-club"
  },
  {
    "name": "cc-discover",
    "prefix": "fab",
    "className": "fab fa-cc-discover"
  },
  {
    "name": "cc-jcb",
    "prefix": "fab",
    "className": "fab fa-cc-jcb"
  },
  {
    "name": "cc-mastercard",
    "prefix": "fab",
    "className": "fab fa-cc-mastercard"
  },
  {
    "name": "cc-paypal",
    "prefix": "fab",
    "className": "fab fa-cc-paypal"
  },
  {
    "name": "cc-stripe",
    "prefix": "fab",
    "className": "fab fa-cc-stripe"
  },
  {
    "name": "cc-visa",
    "prefix": "fab",
    "className": "fab fa-cc-visa"
  },
  {
    "name": "centercode",
    "prefix": "fab",
    "className": "fab fa-centercode"
  },
  {
    "name": "centos",
    "prefix": "fab",
    "className": "fab fa-centos"
  },
  {
    "name": "certificate",
    "prefix": "fas",
    "className": "fas fa-certificate"
  },
  {
    "name": "chair",
    "prefix": "fas",
    "className": "fas fa-chair"
  },
  {
    "name": "chalkboard",
    "prefix": "fas",
    "className": "fas fa-chalkboard"
  },
  {
    "name": "chalkboard-teacher",
    "prefix": "fas",
    "className": "fas fa-chalkboard-teacher"
  },
  {
    "name": "charging-station",
    "prefix": "fas",
    "className": "fas fa-charging-station"
  },
  {
    "name": "chart-area",
    "prefix": "fas",
    "className": "fas fa-chart-area"
  },
  {
    "name": "chart-bar",
    "prefix": "fas",
    "className": "fas fa-chart-bar"
  },
  {
    "name": "chart-line",
    "prefix": "fas",
    "className": "fas fa-chart-line"
  },
  {
    "name": "chart-pie",
    "prefix": "fas",
    "className": "fas fa-chart-pie"
  },
  {
    "name": "check",
    "prefix": "fas",
    "className": "fas fa-check"
  },
  {
    "name": "check-circle",
    "prefix": "fas",
    "className": "fas fa-check-circle"
  },
  {
    "name": "check-double",
    "prefix": "fas",
    "className": "fas fa-check-double"
  },
  {
    "name": "check-square",
    "prefix": "fas",
    "className": "fas fa-check-square"
  },
  {
    "name": "chess",
    "prefix": "fas",
    "className": "fas fa-chess"
  },
  {
    "name": "chess-bishop",
    "prefix": "fas",
    "className": "fas fa-chess-bishop"
  },
  {
    "name": "chess-board",
    "prefix": "fas",
    "className": "fas fa-chess-board"
  },
  {
    "name": "chess-king",
    "prefix": "fas",
    "className": "fas fa-chess-king"
  },
  {
    "name": "chess-knight",
    "prefix": "fas",
    "className": "fas fa-chess-knight"
  },
  {
    "name": "chess-pawn",
    "prefix": "fas",
    "className": "fas fa-chess-pawn"
  },
  {
    "name": "chess-queen",
    "prefix": "fas",
    "className": "fas fa-chess-queen"
  },
  {
    "name": "chess-rook",
    "prefix": "fas",
    "className": "fas fa-chess-rook"
  },
  {
    "name": "chevron-circle-down",
    "prefix": "fas",
    "className": "fas fa-chevron-circle-down"
  },
  {
    "name": "chevron-circle-left",
    "prefix": "fas",
    "className": "fas fa-chevron-circle-left"
  },
  {
    "name": "chevron-circle-right",
    "prefix": "fas",
    "className": "fas fa-chevron-circle-right"
  },
  {
    "name": "chevron-circle-up",
    "prefix": "fas",
    "className": "fas fa-chevron-circle-up"
  },
  {
    "name": "chevron-down",
    "prefix": "fas",
    "className": "fas fa-chevron-down"
  },
  {
    "name": "chevron-left",
    "prefix": "fas",
    "className": "fas fa-chevron-left"
  },
  {
    "name": "chevron-right",
    "prefix": "fas",
    "className": "fas fa-chevron-right"
  },
  {
    "name": "chevron-up",
    "prefix": "fas",
    "className": "fas fa-chevron-up"
  },
  {
    "name": "child",
    "prefix": "fas",
    "className": "fas fa-child"
  },
  {
    "name": "chrome",
    "prefix": "fab",
    "className": "fab fa-chrome"
  },
  {
    "name": "church",
    "prefix": "fas",
    "className": "fas fa-church"
  },
  {
    "name": "circle",
    "prefix": "fas",
    "className": "fas fa-circle"
  },
  {
    "name": "circle-notch",
    "prefix": "fas",
    "className": "fas fa-circle-notch"
  },
  {
    "name": "city",
    "prefix": "fas",
    "className": "fas fa-city"
  },
  {
    "name": "clipboard",
    "prefix": "fas",
    "className": "fas fa-clipboard"
  },
  {
    "name": "clipboard-check",
    "prefix": "fas",
    "className": "fas fa-clipboard-check"
  },
  {
    "name": "clipboard-list",
    "prefix": "fas",
    "className": "fas fa-clipboard-list"
  },
  {
    "name": "clock",
    "prefix": "fas",
    "className": "fas fa-clock"
  },
  {
    "name": "clone",
    "prefix": "fas",
    "className": "fas fa-clone"
  },
  {
    "name": "closed-captioning",
    "prefix": "fas",
    "className": "fas fa-closed-captioning"
  },
  {
    "name": "cloud",
    "prefix": "fas",
    "className": "fas fa-cloud"
  },
  {
    "name": "cloud-download-alt",
    "prefix": "fas",
    "className": "fas fa-cloud-download-alt"
  },
  {
    "name": "cloud-meatball",
    "prefix": "fas",
    "className": "fas fa-cloud-meatball"
  },
  {
    "name": "cloud-moon",
    "prefix": "fas",
    "className": "fas fa-cloud-moon"
  },
  {
    "name": "cloud-moon-rain",
    "prefix": "fas",
    "className": "fas fa-cloud-moon-rain"
  },
  {
    "name": "cloud-rain",
    "prefix": "fas",
    "className": "fas fa-cloud-rain"
  },
  {
    "name": "cloud-showers-heavy",
    "prefix": "fas",
    "className": "fas fa-cloud-showers-heavy"
  },
  {
    "name": "cloud-sun",
    "prefix": "fas",
    "className": "fas fa-cloud-sun"
  },
  {
    "name": "cloud-sun-rain",
    "prefix": "fas",
    "className": "fas fa-cloud-sun-rain"
  },
  {
    "name": "cloud-upload-alt",
    "prefix": "fas",
    "className": "fas fa-cloud-upload-alt"
  },
  {
    "name": "cloudscale",
    "prefix": "fab",
    "className": "fab fa-cloudscale"
  },
  {
    "name": "cloudsmith",
    "prefix": "fab",
    "className": "fab fa-cloudsmith"
  },
  {
    "name": "cloudversify",
    "prefix": "fab",
    "className": "fab fa-cloudversify"
  },
  {
    "name": "cocktail",
    "prefix": "fas",
    "className": "fas fa-cocktail"
  },
  {
    "name": "code",
    "prefix": "fas",
    "className": "fas fa-code"
  },
  {
    "name": "code-branch",
    "prefix": "fas",
    "className": "fas fa-code-branch"
  },
  {
    "name": "codepen",
    "prefix": "fab",
    "className": "fab fa-codepen"
  },
  {
    "name": "codiepie",
    "prefix": "fab",
    "className": "fab fa-codiepie"
  },
  {
    "name": "coffee",
    "prefix": "fas",
    "className": "fas fa-coffee"
  },
  {
    "name": "cog",
    "prefix": "fas",
    "className": "fas fa-cog"
  },
  {
    "name": "cogs",
    "prefix": "fas",
    "className": "fas fa-cogs"
  },
  {
    "name": "coins",
    "prefix": "fas",
    "className": "fas fa-coins"
  },
  {
    "name": "columns",
    "prefix": "fas",
    "className": "fas fa-columns"
  },
  {
    "name": "comment",
    "prefix": "fas",
    "className": "fas fa-comment"
  },
  {
    "name": "comment-alt",
    "prefix": "fas",
    "className": "fas fa-comment-alt"
  },
  {
    "name": "comment-dollar",
    "prefix": "fas",
    "className": "fas fa-comment-dollar"
  },
  {
    "name": "comment-dots",
    "prefix": "fas",
    "className": "fas fa-comment-dots"
  },
  {
    "name": "comment-slash",
    "prefix": "fas",
    "className": "fas fa-comment-slash"
  },
  {
    "name": "comments",
    "prefix": "fas",
    "className": "fas fa-comments"
  },
  {
    "name": "comments-dollar",
    "prefix": "fas",
    "className": "fas fa-comments-dollar"
  },
  {
    "name": "compact-disc",
    "prefix": "fas",
    "className": "fas fa-compact-disc"
  },
  {
    "name": "compass",
    "prefix": "fas",
    "className": "fas fa-compass"
  },
  {
    "name": "compress",
    "prefix": "fas",
    "className": "fas fa-compress"
  },
  {
    "name": "compress-arrows-alt",
    "prefix": "fas",
    "className": "fas fa-compress-arrows-alt"
  },
  {
    "name": "concierge-bell",
    "prefix": "fas",
    "className": "fas fa-concierge-bell"
  },
  {
    "name": "confluence",
    "prefix": "fab",
    "className": "fab fa-confluence"
  },
  {
    "name": "connectdevelop",
    "prefix": "fab",
    "className": "fab fa-connectdevelop"
  },
  {
    "name": "contao",
    "prefix": "fab",
    "className": "fab fa-contao"
  },
  {
    "name": "cookie",
    "prefix": "fas",
    "className": "fas fa-cookie"
  },
  {
    "name": "cookie-bite",
    "prefix": "fas",
    "className": "fas fa-cookie-bite"
  },
  {
    "name": "copy",
    "prefix": "fas",
    "className": "fas fa-copy"
  },
  {
    "name": "copyright",
    "prefix": "fas",
    "className": "fas fa-copyright"
  },
  {
    "name": "couch",
    "prefix": "fas",
    "className": "fas fa-couch"
  },
  {
    "name": "cpanel",
    "prefix": "fab",
    "className": "fab fa-cpanel"
  },
  {
    "name": "creative-commons",
    "prefix": "fab",
    "className": "fab fa-creative-commons"
  },
  {
    "name": "creative-commons-by",
    "prefix": "fab",
    "className": "fab fa-creative-commons-by"
  },
  {
    "name": "creative-commons-nc",
    "prefix": "fab",
    "className": "fab fa-creative-commons-nc"
  },
  {
    "name": "creative-commons-nc-eu",
    "prefix": "fab",
    "className": "fab fa-creative-commons-nc-eu"
  },
  {
    "name": "creative-commons-nc-jp",
    "prefix": "fab",
    "className": "fab fa-creative-commons-nc-jp"
  },
  {
    "name": "creative-commons-nd",
    "prefix": "fab",
    "className": "fab fa-creative-commons-nd"
  },
  {
    "name": "creative-commons-pd",
    "prefix": "fab",
    "className": "fab fa-creative-commons-pd"
  },
  {
    "name": "creative-commons-pd-alt",
    "prefix": "fab",
    "className": "fab fa-creative-commons-pd-alt"
  },
  {
    "name": "creative-commons-remix",
    "prefix": "fab",
    "className": "fab fa-creative-commons-remix"
  },
  {
    "name": "creative-commons-sa",
    "prefix": "fab",
    "className": "fab fa-creative-commons-sa"
  },
  {
    "name": "creative-commons-sampling",
    "prefix": "fab",
    "className": "fab fa-creative-commons-sampling"
  },
  {
    "name": "creative-commons-sampling-plus",
    "prefix": "fab",
    "className": "fab fa-creative-commons-sampling-plus"
  },
  {
    "name": "creative-commons-share",
    "prefix": "fab",
    "className": "fab fa-creative-commons-share"
  },
  {
    "name": "creative-commons-zero",
    "prefix": "fab",
    "className": "fab fa-creative-commons-zero"
  },
  {
    "name": "credit-card",
    "prefix": "fas",
    "className": "fas fa-credit-card"
  },
  {
    "name": "critical-role",
    "prefix": "fab",
    "className": "fab fa-critical-role"
  },
  {
    "name": "crop",
    "prefix": "fas",
    "className": "fas fa-crop"
  },
  {
    "name": "crop-alt",
    "prefix": "fas",
    "className": "fas fa-crop-alt"
  },
  {
    "name": "cross",
    "prefix": "fas",
    "className": "fas fa-cross"
  },
  {
    "name": "crosshairs",
    "prefix": "fas",
    "className": "fas fa-crosshairs"
  },
  {
    "name": "crow",
    "prefix": "fas",
    "className": "fas fa-crow"
  },
  {
    "name": "crown",
    "prefix": "fas",
    "className": "fas fa-crown"
  },
  {
    "name": "css3",
    "prefix": "fab",
    "className": "fab fa-css3"
  },
  {
    "name": "css3-alt",
    "prefix": "fab",
    "className": "fab fa-css3-alt"
  },
  {
    "name": "cube",
    "prefix": "fas",
    "className": "fas fa-cube"
  },
  {
    "name": "cubes",
    "prefix": "fas",
    "className": "fas fa-cubes"
  },
  {
    "name": "cut",
    "prefix": "fas",
    "className": "fas fa-cut"
  },
  {
    "name": "cuttlefish",
    "prefix": "fab",
    "className": "fab fa-cuttlefish"
  },
  {
    "name": "d-and-d",
    "prefix": "fab",
    "className": "fab fa-d-and-d"
  },
  {
    "name": "d-and-d-beyond",
    "prefix": "fab",
    "className": "fab fa-d-and-d-beyond"
  },
  {
    "name": "dashcube",
    "prefix": "fab",
    "className": "fab fa-dashcube"
  },
  {
    "name": "database",
    "prefix": "fas",
    "className": "fas fa-database"
  },
  {
    "name": "deaf",
    "prefix": "fas",
    "className": "fas fa-deaf"
  },
  {
    "name": "delicious",
    "prefix": "fab",
    "className": "fab fa-delicious"
  },
  {
    "name": "democrat",
    "prefix": "fas",
    "className": "fas fa-democrat"
  },
  {
    "name": "deploydog",
    "prefix": "fab",
    "className": "fab fa-deploydog"
  },
  {
    "name": "deskpro",
    "prefix": "fab",
    "className": "fab fa-deskpro"
  },
  {
    "name": "desktop",
    "prefix": "fas",
    "className": "fas fa-desktop"
  },
  {
    "name": "dev",
    "prefix": "fab",
    "className": "fab fa-dev"
  },
  {
    "name": "deviantart",
    "prefix": "fab",
    "className": "fab fa-deviantart"
  },
  {
    "name": "dharmachakra",
    "prefix": "fas",
    "className": "fas fa-dharmachakra"
  },
  {
    "name": "dhl",
    "prefix": "fab",
    "className": "fab fa-dhl"
  },
  {
    "name": "diagnoses",
    "prefix": "fas",
    "className": "fas fa-diagnoses"
  },
  {
    "name": "diaspora",
    "prefix": "fab",
    "className": "fab fa-diaspora"
  },
  {
    "name": "dice",
    "prefix": "fas",
    "className": "fas fa-dice"
  },
  {
    "name": "dice-d20",
    "prefix": "fas",
    "className": "fas fa-dice-d20"
  },
  {
    "name": "dice-d6",
    "prefix": "fas",
    "className": "fas fa-dice-d6"
  },
  {
    "name": "dice-five",
    "prefix": "fas",
    "className": "fas fa-dice-five"
  },
  {
    "name": "dice-four",
    "prefix": "fas",
    "className": "fas fa-dice-four"
  },
  {
    "name": "dice-one",
    "prefix": "fas",
    "className": "fas fa-dice-one"
  },
  {
    "name": "dice-six",
    "prefix": "fas",
    "className": "fas fa-dice-six"
  },
  {
    "name": "dice-three",
    "prefix": "fas",
    "className": "fas fa-dice-three"
  },
  {
    "name": "dice-two",
    "prefix": "fas",
    "className": "fas fa-dice-two"
  },
  {
    "name": "digg",
    "prefix": "fab",
    "className": "fab fa-digg"
  },
  {
    "name": "digital-ocean",
    "prefix": "fab",
    "className": "fab fa-digital-ocean"
  },
  {
    "name": "digital-tachograph",
    "prefix": "fas",
    "className": "fas fa-digital-tachograph"
  },
  {
    "name": "directions",
    "prefix": "fas",
    "className": "fas fa-directions"
  },
  {
    "name": "discord",
    "prefix": "fab",
    "className": "fab fa-discord"
  },
  {
    "name": "discourse",
    "prefix": "fab",
    "className": "fab fa-discourse"
  },
  {
    "name": "divide",
    "prefix": "fas",
    "className": "fas fa-divide"
  },
  {
    "name": "dizzy",
    "prefix": "fas",
    "className": "fas fa-dizzy"
  },
  {
    "name": "dna",
    "prefix": "fas",
    "className": "fas fa-dna"
  },
  {
    "name": "dochub",
    "prefix": "fab",
    "className": "fab fa-dochub"
  },
  {
    "name": "docker",
    "prefix": "fab",
    "className": "fab fa-docker"
  },
  {
    "name": "dog",
    "prefix": "fas",
    "className": "fas fa-dog"
  },
  {
    "name": "dollar-sign",
    "prefix": "fas",
    "className": "fas fa-dollar-sign"
  },
  {
    "name": "dolly",
    "prefix": "fas",
    "className": "fas fa-dolly"
  },
  {
    "name": "dolly-flatbed",
    "prefix": "fas",
    "className": "fas fa-dolly-flatbed"
  },
  {
    "name": "donate",
    "prefix": "fas",
    "className": "fas fa-donate"
  },
  {
    "name": "door-closed",
    "prefix": "fas",
    "className": "fas fa-door-closed"
  },
  {
    "name": "door-open",
    "prefix": "fas",
    "className": "fas fa-door-open"
  },
  {
    "name": "dot-circle",
    "prefix": "fas",
    "className": "fas fa-dot-circle"
  },
  {
    "name": "dove",
    "prefix": "fas",
    "className": "fas fa-dove"
  },
  {
    "name": "download",
    "prefix": "fas",
    "className": "fas fa-download"
  },
  {
    "name": "draft2digital",
    "prefix": "fab",
    "className": "fab fa-draft2digital"
  },
  {
    "name": "drafting-compass",
    "prefix": "fas",
    "className": "fas fa-drafting-compass"
  },
  {
    "name": "dragon",
    "prefix": "fas",
    "className": "fas fa-dragon"
  },
  {
    "name": "draw-polygon",
    "prefix": "fas",
    "className": "fas fa-draw-polygon"
  },
  {
    "name": "dribbble",
    "prefix": "fab",
    "className": "fab fa-dribbble"
  },
  {
    "name": "dribbble-square",
    "prefix": "fab",
    "className": "fab fa-dribbble-square"
  },
  {
    "name": "dropbox",
    "prefix": "fab",
    "className": "fab fa-dropbox"
  },
  {
    "name": "drum",
    "prefix": "fas",
    "className": "fas fa-drum"
  },
  {
    "name": "drum-steelpan",
    "prefix": "fas",
    "className": "fas fa-drum-steelpan"
  },
  {
    "name": "drumstick-bite",
    "prefix": "fas",
    "className": "fas fa-drumstick-bite"
  },
  {
    "name": "drupal",
    "prefix": "fab",
    "className": "fab fa-drupal"
  },
  {
    "name": "dumbbell",
    "prefix": "fas",
    "className": "fas fa-dumbbell"
  },
  {
    "name": "dumpster",
    "prefix": "fas",
    "className": "fas fa-dumpster"
  },
  {
    "name": "dumpster-fire",
    "prefix": "fas",
    "className": "fas fa-dumpster-fire"
  },
  {
    "name": "dungeon",
    "prefix": "fas",
    "className": "fas fa-dungeon"
  },
  {
    "name": "dyalog",
    "prefix": "fab",
    "className": "fab fa-dyalog"
  },
  {
    "name": "earlybirds",
    "prefix": "fab",
    "className": "fab fa-earlybirds"
  },
  {
    "name": "ebay",
    "prefix": "fab",
    "className": "fab fa-ebay"
  },
  {
    "name": "edge",
    "prefix": "fab",
    "className": "fab fa-edge"
  },
  {
    "name": "edit",
    "prefix": "fas",
    "className": "fas fa-edit"
  },
  {
    "name": "eject",
    "prefix": "fas",
    "className": "fas fa-eject"
  },
  {
    "name": "elementor",
    "prefix": "fab",
    "className": "fab fa-elementor"
  },
  {
    "name": "ellipsis-h",
    "prefix": "fas",
    "className": "fas fa-ellipsis-h"
  },
  {
    "name": "ellipsis-v",
    "prefix": "fas",
    "className": "fas fa-ellipsis-v"
  },
  {
    "name": "ello",
    "prefix": "fab",
    "className": "fab fa-ello"
  },
  {
    "name": "ember",
    "prefix": "fab",
    "className": "fab fa-ember"
  },
  {
    "name": "empire",
    "prefix": "fab",
    "className": "fab fa-empire"
  },
  {
    "name": "envelope",
    "prefix": "fas",
    "className": "fas fa-envelope"
  },
  {
    "name": "envelope-open",
    "prefix": "fas",
    "className": "fas fa-envelope-open"
  },
  {
    "name": "envelope-open-text",
    "prefix": "fas",
    "className": "fas fa-envelope-open-text"
  },
  {
    "name": "envelope-square",
    "prefix": "fas",
    "className": "fas fa-envelope-square"
  },
  {
    "name": "envira",
    "prefix": "fab",
    "className": "fab fa-envira"
  },
  {
    "name": "equals",
    "prefix": "fas",
    "className": "fas fa-equals"
  },
  {
    "name": "eraser",
    "prefix": "fas",
    "className": "fas fa-eraser"
  },
  {
    "name": "erlang",
    "prefix": "fab",
    "className": "fab fa-erlang"
  },
  {
    "name": "ethereum",
    "prefix": "fab",
    "className": "fab fa-ethereum"
  },
  {
    "name": "ethernet",
    "prefix": "fas",
    "className": "fas fa-ethernet"
  },
  {
    "name": "etsy",
    "prefix": "fab",
    "className": "fab fa-etsy"
  },
  {
    "name": "euro-sign",
    "prefix": "fas",
    "className": "fas fa-euro-sign"
  },
  {
    "name": "exchange-alt",
    "prefix": "fas",
    "className": "fas fa-exchange-alt"
  },
  {
    "name": "exclamation",
    "prefix": "fas",
    "className": "fas fa-exclamation"
  },
  {
    "name": "exclamation-circle",
    "prefix": "fas",
    "className": "fas fa-exclamation-circle"
  },
  {
    "name": "exclamation-triangle",
    "prefix": "fas",
    "className": "fas fa-exclamation-triangle"
  },
  {
    "name": "expand",
    "prefix": "fas",
    "className": "fas fa-expand"
  },
  {
    "name": "expand-arrows-alt",
    "prefix": "fas",
    "className": "fas fa-expand-arrows-alt"
  },
  {
    "name": "expeditedssl",
    "prefix": "fab",
    "className": "fab fa-expeditedssl"
  },
  {
    "name": "external-link-alt",
    "prefix": "fas",
    "className": "fas fa-external-link-alt"
  },
  {
    "name": "external-link-square-alt",
    "prefix": "fas",
    "className": "fas fa-external-link-square-alt"
  },
  {
    "name": "eye",
    "prefix": "fas",
    "className": "fas fa-eye"
  },
  {
    "name": "eye-dropper",
    "prefix": "fas",
    "className": "fas fa-eye-dropper"
  },
  {
    "name": "eye-slash",
    "prefix": "fas",
    "className": "fas fa-eye-slash"
  },
  {
    "name": "facebook",
    "prefix": "fab",
    "className": "fab fa-facebook"
  },
  {
    "name": "facebook-f",
    "prefix": "fab",
    "className": "fab fa-facebook-f"
  },
  {
    "name": "facebook-messenger",
    "prefix": "fab",
    "className": "fab fa-facebook-messenger"
  },
  {
    "name": "facebook-square",
    "prefix": "fab",
    "className": "fab fa-facebook-square"
  },
  {
    "name": "fantasy-flight-games",
    "prefix": "fab",
    "className": "fab fa-fantasy-flight-games"
  },
  {
    "name": "fast-backward",
    "prefix": "fas",
    "className": "fas fa-fast-backward"
  },
  {
    "name": "fast-forward",
    "prefix": "fas",
    "className": "fas fa-fast-forward"
  },
  {
    "name": "fax",
    "prefix": "fas",
    "className": "fas fa-fax"
  },
  {
    "name": "feather",
    "prefix": "fas",
    "className": "fas fa-feather"
  },
  {
    "name": "feather-alt",
    "prefix": "fas",
    "className": "fas fa-feather-alt"
  },
  {
    "name": "fedex",
    "prefix": "fab",
    "className": "fab fa-fedex"
  },
  {
    "name": "fedora",
    "prefix": "fab",
    "className": "fab fa-fedora"
  },
  {
    "name": "female",
    "prefix": "fas",
    "className": "fas fa-female"
  },
  {
    "name": "fighter-jet",
    "prefix": "fas",
    "className": "fas fa-fighter-jet"
  },
  {
    "name": "figma",
    "prefix": "fab",
    "className": "fab fa-figma"
  },
  {
    "name": "file",
    "prefix": "fas",
    "className": "fas fa-file"
  },
  {
    "name": "file-alt",
    "prefix": "fas",
    "className": "fas fa-file-alt"
  },
  {
    "name": "file-archive",
    "prefix": "fas",
    "className": "fas fa-file-archive"
  },
  {
    "name": "file-audio",
    "prefix": "fas",
    "className": "fas fa-file-audio"
  },
  {
    "name": "file-code",
    "prefix": "fas",
    "className": "fas fa-file-code"
  },
  {
    "name": "file-contract",
    "prefix": "fas",
    "className": "fas fa-file-contract"
  },
  {
    "name": "file-csv",
    "prefix": "fas",
    "className": "fas fa-file-csv"
  },
  {
    "name": "file-download",
    "prefix": "fas",
    "className": "fas fa-file-download"
  },
  {
    "name": "file-excel",
    "prefix": "fas",
    "className": "fas fa-file-excel"
  },
  {
    "name": "file-export",
    "prefix": "fas",
    "className": "fas fa-file-export"
  },
  {
    "name": "file-image",
    "prefix": "fas",
    "className": "fas fa-file-image"
  },
  {
    "name": "file-import",
    "prefix": "fas",
    "className": "fas fa-file-import"
  },
  {
    "name": "file-invoice",
    "prefix": "fas",
    "className": "fas fa-file-invoice"
  },
  {
    "name": "file-invoice-dollar",
    "prefix": "fas",
    "className": "fas fa-file-invoice-dollar"
  },
  {
    "name": "file-medical",
    "prefix": "fas",
    "className": "fas fa-file-medical"
  },
  {
    "name": "file-medical-alt",
    "prefix": "fas",
    "className": "fas fa-file-medical-alt"
  },
  {
    "name": "file-pdf",
    "prefix": "fas",
    "className": "fas fa-file-pdf"
  },
  {
    "name": "file-powerpoint",
    "prefix": "fas",
    "className": "fas fa-file-powerpoint"
  },
  {
    "name": "file-prescription",
    "prefix": "fas",
    "className": "fas fa-file-prescription"
  },
  {
    "name": "file-signature",
    "prefix": "fas",
    "className": "fas fa-file-signature"
  },
  {
    "name": "file-upload",
    "prefix": "fas",
    "className": "fas fa-file-upload"
  },
  {
    "name": "file-video",
    "prefix": "fas",
    "className": "fas fa-file-video"
  },
  {
    "name": "file-word",
    "prefix": "fas",
    "className": "fas fa-file-word"
  },
  {
    "name": "fill",
    "prefix": "fas",
    "className": "fas fa-fill"
  },
  {
    "name": "fill-drip",
    "prefix": "fas",
    "className": "fas fa-fill-drip"
  },
  {
    "name": "film",
    "prefix": "fas",
    "className": "fas fa-film"
  },
  {
    "name": "filter",
    "prefix": "fas",
    "className": "fas fa-filter"
  },
  {
    "name": "fingerprint",
    "prefix": "fas",
    "className": "fas fa-fingerprint"
  },
  {
    "name": "fire",
    "prefix": "fas",
    "className": "fas fa-fire"
  },
  {
    "name": "fire-alt",
    "prefix": "fas",
    "className": "fas fa-fire-alt"
  },
  {
    "name": "fire-extinguisher",
    "prefix": "fas",
    "className": "fas fa-fire-extinguisher"
  },
  {
    "name": "firefox",
    "prefix": "fab",
    "className": "fab fa-firefox"
  },
  {
    "name": "first-aid",
    "prefix": "fas",
    "className": "fas fa-first-aid"
  },
  {
    "name": "first-order",
    "prefix": "fab",
    "className": "fab fa-first-order"
  },
  {
    "name": "first-order-alt",
    "prefix": "fab",
    "className": "fab fa-first-order-alt"
  },
  {
    "name": "firstdraft",
    "prefix": "fab",
    "className": "fab fa-firstdraft"
  },
  {
    "name": "fish",
    "prefix": "fas",
    "className": "fas fa-fish"
  },
  {
    "name": "fist-raised",
    "prefix": "fas",
    "className": "fas fa-fist-raised"
  },
  {
    "name": "flag",
    "prefix": "fas",
    "className": "fas fa-flag"
  },
  {
    "name": "flag-checkered",
    "prefix": "fas",
    "className": "fas fa-flag-checkered"
  },
  {
    "name": "flag-usa",
    "prefix": "fas",
    "className": "fas fa-flag-usa"
  },
  {
    "name": "flask",
    "prefix": "fas",
    "className": "fas fa-flask"
  },
  {
    "name": "flickr",
    "prefix": "fab",
    "className": "fab fa-flickr"
  },
  {
    "name": "flipboard",
    "prefix": "fab",
    "className": "fab fa-flipboard"
  },
  {
    "name": "flushed",
    "prefix": "fas",
    "className": "fas fa-flushed"
  },
  {
    "name": "fly",
    "prefix": "fab",
    "className": "fab fa-fly"
  },
  {
    "name": "folder",
    "prefix": "fas",
    "className": "fas fa-folder"
  },
  {
    "name": "folder-minus",
    "prefix": "fas",
    "className": "fas fa-folder-minus"
  },
  {
    "name": "folder-open",
    "prefix": "fas",
    "className": "fas fa-folder-open"
  },
  {
    "name": "folder-plus",
    "prefix": "fas",
    "className": "fas fa-folder-plus"
  },
  {
    "name": "font",
    "prefix": "fas",
    "className": "fas fa-font"
  },
  {
    "name": "font-awesome",
    "prefix": "fab",
    "className": "fab fa-font-awesome"
  },
  {
    "name": "font-awesome-alt",
    "prefix": "fab",
    "className": "fab fa-font-awesome-alt"
  },
  {
    "name": "font-awesome-flag",
    "prefix": "fab",
    "className": "fab fa-font-awesome-flag"
  },
  {
    "name": "font-awesome-logo-full",
    "prefix": "fab",
    "className": "fab fa-font-awesome-logo-full"
  },
  {
    "name": "fonticons",
    "prefix": "fab",
    "className": "fab fa-fonticons"
  },
  {
    "name": "fonticons-fi",
    "prefix": "fab",
    "className": "fab fa-fonticons-fi"
  },
  {
    "name": "football-ball",
    "prefix": "fas",
    "className": "fas fa-football-ball"
  },
  {
    "name": "fort-awesome",
    "prefix": "fab",
    "className": "fab fa-fort-awesome"
  },
  {
    "name": "fort-awesome-alt",
    "prefix": "fab",
    "className": "fab fa-fort-awesome-alt"
  },
  {
    "name": "forumbee",
    "prefix": "fab",
    "className": "fab fa-forumbee"
  },
  {
    "name": "forward",
    "prefix": "fas",
    "className": "fas fa-forward"
  },
  {
    "name": "foursquare",
    "prefix": "fab",
    "className": "fab fa-foursquare"
  },
  {
    "name": "free-code-camp",
    "prefix": "fab",
    "className": "fab fa-free-code-camp"
  },
  {
    "name": "freebsd",
    "prefix": "fab",
    "className": "fab fa-freebsd"
  },
  {
    "name": "frog",
    "prefix": "fas",
    "className": "fas fa-frog"
  },
  {
    "name": "frown",
    "prefix": "fas",
    "className": "fas fa-frown"
  },
  {
    "name": "frown-open",
    "prefix": "fas",
    "className": "fas fa-frown-open"
  },
  {
    "name": "fulcrum",
    "prefix": "fab",
    "className": "fab fa-fulcrum"
  },
  {
    "name": "funnel-dollar",
    "prefix": "fas",
    "className": "fas fa-funnel-dollar"
  },
  {
    "name": "futbol",
    "prefix": "fas",
    "className": "fas fa-futbol"
  },
  {
    "name": "galactic-republic",
    "prefix": "fab",
    "className": "fab fa-galactic-republic"
  },
  {
    "name": "galactic-senate",
    "prefix": "fab",
    "className": "fab fa-galactic-senate"
  },
  {
    "name": "gamepad",
    "prefix": "fas",
    "className": "fas fa-gamepad"
  },
  {
    "name": "gas-pump",
    "prefix": "fas",
    "className": "fas fa-gas-pump"
  },
  {
    "name": "gavel",
    "prefix": "fas",
    "className": "fas fa-gavel"
  },
  {
    "name": "gem",
    "prefix": "fas",
    "className": "fas fa-gem"
  },
  {
    "name": "genderless",
    "prefix": "fas",
    "className": "fas fa-genderless"
  },
  {
    "name": "get-pocket",
    "prefix": "fab",
    "className": "fab fa-get-pocket"
  },
  {
    "name": "gg",
    "prefix": "fab",
    "className": "fab fa-gg"
  },
  {
    "name": "gg-circle",
    "prefix": "fab",
    "className": "fab fa-gg-circle"
  },
  {
    "name": "ghost",
    "prefix": "fas",
    "className": "fas fa-ghost"
  },
  {
    "name": "gift",
    "prefix": "fas",
    "className": "fas fa-gift"
  },
  {
    "name": "gifts",
    "prefix": "fas",
    "className": "fas fa-gifts"
  },
  {
    "name": "git",
    "prefix": "fab",
    "className": "fab fa-git"
  },
  {
    "name": "git-square",
    "prefix": "fab",
    "className": "fab fa-git-square"
  },
  {
    "name": "github",
    "prefix": "fab",
    "className": "fab fa-github"
  },
  {
    "name": "github-alt",
    "prefix": "fab",
    "className": "fab fa-github-alt"
  },
  {
    "name": "github-square",
    "prefix": "fab",
    "className": "fab fa-github-square"
  },
  {
    "name": "gitkraken",
    "prefix": "fab",
    "className": "fab fa-gitkraken"
  },
  {
    "name": "gitlab",
    "prefix": "fab",
    "className": "fab fa-gitlab"
  },
  {
    "name": "gitter",
    "prefix": "fab",
    "className": "fab fa-gitter"
  },
  {
    "name": "glass-cheers",
    "prefix": "fas",
    "className": "fas fa-glass-cheers"
  },
  {
    "name": "glass-martini",
    "prefix": "fas",
    "className": "fas fa-glass-martini"
  },
  {
    "name": "glass-martini-alt",
    "prefix": "fas",
    "className": "fas fa-glass-martini-alt"
  },
  {
    "name": "glass-whiskey",
    "prefix": "fas",
    "className": "fas fa-glass-whiskey"
  },
  {
    "name": "glasses",
    "prefix": "fas",
    "className": "fas fa-glasses"
  },
  {
    "name": "glide",
    "prefix": "fab",
    "className": "fab fa-glide"
  },
  {
    "name": "glide-g",
    "prefix": "fab",
    "className": "fab fa-glide-g"
  },
  {
    "name": "globe",
    "prefix": "fas",
    "className": "fas fa-globe"
  },
  {
    "name": "globe-africa",
    "prefix": "fas",
    "className": "fas fa-globe-africa"
  },
  {
    "name": "globe-americas",
    "prefix": "fas",
    "className": "fas fa-globe-americas"
  },
  {
    "name": "globe-asia",
    "prefix": "fas",
    "className": "fas fa-globe-asia"
  },
  {
    "name": "globe-europe",
    "prefix": "fas",
    "className": "fas fa-globe-europe"
  },
  {
    "name": "gofore",
    "prefix": "fab",
    "className": "fab fa-gofore"
  },
  {
    "name": "golf-ball",
    "prefix": "fas",
    "className": "fas fa-golf-ball"
  },
  {
    "name": "goodreads",
    "prefix": "fab",
    "className": "fab fa-goodreads"
  },
  {
    "name": "goodreads-g",
    "prefix": "fab",
    "className": "fab fa-goodreads-g"
  },
  {
    "name": "google",
    "prefix": "fab",
    "className": "fab fa-google"
  },
  {
    "name": "google-drive",
    "prefix": "fab",
    "className": "fab fa-google-drive"
  },
  {
    "name": "google-play",
    "prefix": "fab",
    "className": "fab fa-google-play"
  },
  {
    "name": "google-plus",
    "prefix": "fab",
    "className": "fab fa-google-plus"
  },
  {
    "name": "google-plus-g",
    "prefix": "fab",
    "className": "fab fa-google-plus-g"
  },
  {
    "name": "google-plus-square",
    "prefix": "fab",
    "className": "fab fa-google-plus-square"
  },
  {
    "name": "google-wallet",
    "prefix": "fab",
    "className": "fab fa-google-wallet"
  },
  {
    "name": "gopuram",
    "prefix": "fas",
    "className": "fas fa-gopuram"
  },
  {
    "name": "graduation-cap",
    "prefix": "fas",
    "className": "fas fa-graduation-cap"
  },
  {
    "name": "gratipay",
    "prefix": "fab",
    "className": "fab fa-gratipay"
  },
  {
    "name": "grav",
    "prefix": "fab",
    "className": "fab fa-grav"
  },
  {
    "name": "greater-than",
    "prefix": "fas",
    "className": "fas fa-greater-than"
  },
  {
    "name": "greater-than-equal",
    "prefix": "fas",
    "className": "fas fa-greater-than-equal"
  },
  {
    "name": "grimace",
    "prefix": "fas",
    "className": "fas fa-grimace"
  },
  {
    "name": "grin",
    "prefix": "fas",
    "className": "fas fa-grin"
  },
  {
    "name": "grin-alt",
    "prefix": "fas",
    "className": "fas fa-grin-alt"
  },
  {
    "name": "grin-beam",
    "prefix": "fas",
    "className": "fas fa-grin-beam"
  },
  {
    "name": "grin-beam-sweat",
    "prefix": "fas",
    "className": "fas fa-grin-beam-sweat"
  },
  {
    "name": "grin-hearts",
    "prefix": "fas",
    "className": "fas fa-grin-hearts"
  },
  {
    "name": "grin-squint",
    "prefix": "fas",
    "className": "fas fa-grin-squint"
  },
  {
    "name": "grin-squint-tears",
    "prefix": "fas",
    "className": "fas fa-grin-squint-tears"
  },
  {
    "name": "grin-stars",
    "prefix": "fas",
    "className": "fas fa-grin-stars"
  },
  {
    "name": "grin-tears",
    "prefix": "fas",
    "className": "fas fa-grin-tears"
  },
  {
    "name": "grin-tongue",
    "prefix": "fas",
    "className": "fas fa-grin-tongue"
  },
  {
    "name": "grin-tongue-squint",
    "prefix": "fas",
    "className": "fas fa-grin-tongue-squint"
  },
  {
    "name": "grin-tongue-wink",
    "prefix": "fas",
    "className": "fas fa-grin-tongue-wink"
  },
  {
    "name": "grin-wink",
    "prefix": "fas",
    "className": "fas fa-grin-wink"
  },
  {
    "name": "grip-horizontal",
    "prefix": "fas",
    "className": "fas fa-grip-horizontal"
  },
  {
    "name": "grip-lines",
    "prefix": "fas",
    "className": "fas fa-grip-lines"
  },
  {
    "name": "grip-lines-vertical",
    "prefix": "fas",
    "className": "fas fa-grip-lines-vertical"
  },
  {
    "name": "grip-vertical",
    "prefix": "fas",
    "className": "fas fa-grip-vertical"
  },
  {
    "name": "gripfire",
    "prefix": "fab",
    "className": "fab fa-gripfire"
  },
  {
    "name": "grunt",
    "prefix": "fab",
    "className": "fab fa-grunt"
  },
  {
    "name": "guitar",
    "prefix": "fas",
    "className": "fas fa-guitar"
  },
  {
    "name": "gulp",
    "prefix": "fab",
    "className": "fab fa-gulp"
  },
  {
    "name": "h-square",
    "prefix": "fas",
    "className": "fas fa-h-square"
  },
  {
    "name": "hacker-news",
    "prefix": "fab",
    "className": "fab fa-hacker-news"
  },
  {
    "name": "hacker-news-square",
    "prefix": "fab",
    "className": "fab fa-hacker-news-square"
  },
  {
    "name": "hackerrank",
    "prefix": "fab",
    "className": "fab fa-hackerrank"
  },
  {
    "name": "hammer",
    "prefix": "fas",
    "className": "fas fa-hammer"
  },
  {
    "name": "hamsa",
    "prefix": "fas",
    "className": "fas fa-hamsa"
  },
  {
    "name": "hand-holding",
    "prefix": "fas",
    "className": "fas fa-hand-holding"
  },
  {
    "name": "hand-holding-heart",
    "prefix": "fas",
    "className": "fas fa-hand-holding-heart"
  },
  {
    "name": "hand-holding-usd",
    "prefix": "fas",
    "className": "fas fa-hand-holding-usd"
  },
  {
    "name": "hand-lizard",
    "prefix": "fas",
    "className": "fas fa-hand-lizard"
  },
  {
    "name": "hand-paper",
    "prefix": "fas",
    "className": "fas fa-hand-paper"
  },
  {
    "name": "hand-peace",
    "prefix": "fas",
    "className": "fas fa-hand-peace"
  },
  {
    "name": "hand-point-down",
    "prefix": "fas",
    "className": "fas fa-hand-point-down"
  },
  {
    "name": "hand-point-left",
    "prefix": "fas",
    "className": "fas fa-hand-point-left"
  },
  {
    "name": "hand-point-right",
    "prefix": "fas",
    "className": "fas fa-hand-point-right"
  },
  {
    "name": "hand-point-up",
    "prefix": "fas",
    "className": "fas fa-hand-point-up"
  },
  {
    "name": "hand-pointer",
    "prefix": "fas",
    "className": "fas fa-hand-pointer"
  },
  {
    "name": "hand-rock",
    "prefix": "fas",
    "className": "fas fa-hand-rock"
  },
  {
    "name": "hand-scissors",
    "prefix": "fas",
    "className": "fas fa-hand-scissors"
  },
  {
    "name": "hand-spock",
    "prefix": "fas",
    "className": "fas fa-hand-spock"
  },
  {
    "name": "hands",
    "prefix": "fas",
    "className": "fas fa-hands"
  },
  {
    "name": "hands-helping",
    "prefix": "fas",
    "className": "fas fa-hands-helping"
  },
  {
    "name": "handshake",
    "prefix": "fas",
    "className": "fas fa-handshake"
  },
  {
    "name": "hanukiah",
    "prefix": "fas",
    "className": "fas fa-hanukiah"
  },
  {
    "name": "hashtag",
    "prefix": "fas",
    "className": "fas fa-hashtag"
  },
  {
    "name": "hat-wizard",
    "prefix": "fas",
    "className": "fas fa-hat-wizard"
  },
  {
    "name": "haykal",
    "prefix": "fas",
    "className": "fas fa-haykal"
  },
  {
    "name": "hdd",
    "prefix": "fas",
    "className": "fas fa-hdd"
  },
  {
    "name": "heading",
    "prefix": "fas",
    "className": "fas fa-heading"
  },
  {
    "name": "headphones",
    "prefix": "fas",
    "className": "fas fa-headphones"
  },
  {
    "name": "headphones-alt",
    "prefix": "fas",
    "className": "fas fa-headphones-alt"
  },
  {
    "name": "headset",
    "prefix": "fas",
    "className": "fas fa-headset"
  },
  {
    "name": "heart",
    "prefix": "fas",
    "className": "fas fa-heart"
  },
  {
    "name": "heart-broken",
    "prefix": "fas",
    "className": "fas fa-heart-broken"
  },
  {
    "name": "heartbeat",
    "prefix": "fas",
    "className": "fas fa-heartbeat"
  },
  {
    "name": "helicopter",
    "prefix": "fas",
    "className": "fas fa-helicopter"
  },
  {
    "name": "highlighter",
    "prefix": "fas",
    "className": "fas fa-highlighter"
  },
  {
    "name": "hiking",
    "prefix": "fas",
    "className": "fas fa-hiking"
  },
  {
    "name": "hippo",
    "prefix": "fas",
    "className": "fas fa-hippo"
  },
  {
    "name": "hips",
    "prefix": "fab",
    "className": "fab fa-hips"
  },
  {
    "name": "hire-a-helper",
    "prefix": "fab",
    "className": "fab fa-hire-a-helper"
  },
  {
    "name": "history",
    "prefix": "fas",
    "className": "fas fa-history"
  },
  {
    "name": "hockey-puck",
    "prefix": "fas",
    "className": "fas fa-hockey-puck"
  },
  {
    "name": "holly-berry",
    "prefix": "fas",
    "className": "fas fa-holly-berry"
  },
  {
    "name": "home",
    "prefix": "fas",
    "className": "fas fa-home"
  },
  {
    "name": "hooli",
    "prefix": "fab",
    "className": "fab fa-hooli"
  },
  {
    "name": "hornbill",
    "prefix": "fab",
    "className": "fab fa-hornbill"
  },
  {
    "name": "horse",
    "prefix": "fas",
    "className": "fas fa-horse"
  },
  {
    "name": "horse-head",
    "prefix": "fas",
    "className": "fas fa-horse-head"
  },
  {
    "name": "hospital",
    "prefix": "fas",
    "className": "fas fa-hospital"
  },
  {
    "name": "hospital-alt",
    "prefix": "fas",
    "className": "fas fa-hospital-alt"
  },
  {
    "name": "hospital-symbol",
    "prefix": "fas",
    "className": "fas fa-hospital-symbol"
  },
  {
    "name": "hot-tub",
    "prefix": "fas",
    "className": "fas fa-hot-tub"
  },
  {
    "name": "hotel",
    "prefix": "fas",
    "className": "fas fa-hotel"
  },
  {
    "name": "hotjar",
    "prefix": "fab",
    "className": "fab fa-hotjar"
  },
  {
    "name": "hourglass",
    "prefix": "fas",
    "className": "fas fa-hourglass"
  },
  {
    "name": "hourglass-end",
    "prefix": "fas",
    "className": "fas fa-hourglass-end"
  },
  {
    "name": "hourglass-half",
    "prefix": "fas",
    "className": "fas fa-hourglass-half"
  },
  {
    "name": "hourglass-start",
    "prefix": "fas",
    "className": "fas fa-hourglass-start"
  },
  {
    "name": "house-damage",
    "prefix": "fas",
    "className": "fas fa-house-damage"
  },
  {
    "name": "houzz",
    "prefix": "fab",
    "className": "fab fa-houzz"
  },
  {
    "name": "hryvnia",
    "prefix": "fas",
    "className": "fas fa-hryvnia"
  },
  {
    "name": "html5",
    "prefix": "fab",
    "className": "fab fa-html5"
  },
  {
    "name": "hubspot",
    "prefix": "fab",
    "className": "fab fa-hubspot"
  },
  {
    "name": "i-cursor",
    "prefix": "fas",
    "className": "fas fa-i-cursor"
  },
  {
    "name": "icicles",
    "prefix": "fas",
    "className": "fas fa-icicles"
  },
  {
    "name": "id-badge",
    "prefix": "fas",
    "className": "fas fa-id-badge"
  },
  {
    "name": "id-card",
    "prefix": "fas",
    "className": "fas fa-id-card"
  },
  {
    "name": "id-card-alt",
    "prefix": "fas",
    "className": "fas fa-id-card-alt"
  },
  {
    "name": "igloo",
    "prefix": "fas",
    "className": "fas fa-igloo"
  },
  {
    "name": "image",
    "prefix": "fas",
    "className": "fas fa-image"
  },
  {
    "name": "images",
    "prefix": "fas",
    "className": "fas fa-images"
  },
  {
    "name": "imdb",
    "prefix": "fab",
    "className": "fab fa-imdb"
  },
  {
    "name": "inbox",
    "prefix": "fas",
    "className": "fas fa-inbox"
  },
  {
    "name": "indent",
    "prefix": "fas",
    "className": "fas fa-indent"
  },
  {
    "name": "industry",
    "prefix": "fas",
    "className": "fas fa-industry"
  },
  {
    "name": "infinity",
    "prefix": "fas",
    "className": "fas fa-infinity"
  },
  {
    "name": "info",
    "prefix": "fas",
    "className": "fas fa-info"
  },
  {
    "name": "info-circle",
    "prefix": "fas",
    "className": "fas fa-info-circle"
  },
  {
    "name": "instagram",
    "prefix": "fab",
    "className": "fab fa-instagram"
  },
  {
    "name": "intercom",
    "prefix": "fab",
    "className": "fab fa-intercom"
  },
  {
    "name": "internet-explorer",
    "prefix": "fab",
    "className": "fab fa-internet-explorer"
  },
  {
    "name": "invision",
    "prefix": "fab",
    "className": "fab fa-invision"
  },
  {
    "name": "ioxhost",
    "prefix": "fab",
    "className": "fab fa-ioxhost"
  },
  {
    "name": "italic",
    "prefix": "fas",
    "className": "fas fa-italic"
  },
  {
    "name": "itunes",
    "prefix": "fab",
    "className": "fab fa-itunes"
  },
  {
    "name": "itunes-note",
    "prefix": "fab",
    "className": "fab fa-itunes-note"
  },
  {
    "name": "java",
    "prefix": "fab",
    "className": "fab fa-java"
  },
  {
    "name": "jedi",
    "prefix": "fas",
    "className": "fas fa-jedi"
  },
  {
    "name": "jedi-order",
    "prefix": "fab",
    "className": "fab fa-jedi-order"
  },
  {
    "name": "jenkins",
    "prefix": "fab",
    "className": "fab fa-jenkins"
  },
  {
    "name": "jira",
    "prefix": "fab",
    "className": "fab fa-jira"
  },
  {
    "name": "joget",
    "prefix": "fab",
    "className": "fab fa-joget"
  },
  {
    "name": "joint",
    "prefix": "fas",
    "className": "fas fa-joint"
  },
  {
    "name": "joomla",
    "prefix": "fab",
    "className": "fab fa-joomla"
  },
  {
    "name": "journal-whills",
    "prefix": "fas",
    "className": "fas fa-journal-whills"
  },
  {
    "name": "js",
    "prefix": "fab",
    "className": "fab fa-js"
  },
  {
    "name": "js-square",
    "prefix": "fab",
    "className": "fab fa-js-square"
  },
  {
    "name": "jsfiddle",
    "prefix": "fab",
    "className": "fab fa-jsfiddle"
  },
  {
    "name": "kaaba",
    "prefix": "fas",
    "className": "fas fa-kaaba"
  },
  {
    "name": "kaggle",
    "prefix": "fab",
    "className": "fab fa-kaggle"
  },
  {
    "name": "key",
    "prefix": "fas",
    "className": "fas fa-key"
  },
  {
    "name": "keybase",
    "prefix": "fab",
    "className": "fab fa-keybase"
  },
  {
    "name": "keyboard",
    "prefix": "fas",
    "className": "fas fa-keyboard"
  },
  {
    "name": "keycdn",
    "prefix": "fab",
    "className": "fab fa-keycdn"
  },
  {
    "name": "khanda",
    "prefix": "fas",
    "className": "fas fa-khanda"
  },
  {
    "name": "kickstarter",
    "prefix": "fab",
    "className": "fab fa-kickstarter"
  },
  {
    "name": "kickstarter-k",
    "prefix": "fab",
    "className": "fab fa-kickstarter-k"
  },
  {
    "name": "kiss",
    "prefix": "fas",
    "className": "fas fa-kiss"
  },
  {
    "name": "kiss-beam",
    "prefix": "fas",
    "className": "fas fa-kiss-beam"
  },
  {
    "name": "kiss-wink-heart",
    "prefix": "fas",
    "className": "fas fa-kiss-wink-heart"
  },
  {
    "name": "kiwi-bird",
    "prefix": "fas",
    "className": "fas fa-kiwi-bird"
  },
  {
    "name": "korvue",
    "prefix": "fab",
    "className": "fab fa-korvue"
  },
  {
    "name": "landmark",
    "prefix": "fas",
    "className": "fas fa-landmark"
  },
  {
    "name": "language",
    "prefix": "fas",
    "className": "fas fa-language"
  },
  {
    "name": "laptop",
    "prefix": "fas",
    "className": "fas fa-laptop"
  },
  {
    "name": "laptop-code",
    "prefix": "fas",
    "className": "fas fa-laptop-code"
  },
  {
    "name": "laravel",
    "prefix": "fab",
    "className": "fab fa-laravel"
  },
  {
    "name": "lastfm",
    "prefix": "fab",
    "className": "fab fa-lastfm"
  },
  {
    "name": "lastfm-square",
    "prefix": "fab",
    "className": "fab fa-lastfm-square"
  },
  {
    "name": "laugh",
    "prefix": "fas",
    "className": "fas fa-laugh"
  },
  {
    "name": "laugh-beam",
    "prefix": "fas",
    "className": "fas fa-laugh-beam"
  },
  {
    "name": "laugh-squint",
    "prefix": "fas",
    "className": "fas fa-laugh-squint"
  },
  {
    "name": "laugh-wink",
    "prefix": "fas",
    "className": "fas fa-laugh-wink"
  },
  {
    "name": "layer-group",
    "prefix": "fas",
    "className": "fas fa-layer-group"
  },
  {
    "name": "leaf",
    "prefix": "fas",
    "className": "fas fa-leaf"
  },
  {
    "name": "leanpub",
    "prefix": "fab",
    "className": "fab fa-leanpub"
  },
  {
    "name": "lemon",
    "prefix": "fas",
    "className": "fas fa-lemon"
  },
  {
    "name": "less",
    "prefix": "fab",
    "className": "fab fa-less"
  },
  {
    "name": "less-than",
    "prefix": "fas",
    "className": "fas fa-less-than"
  },
  {
    "name": "less-than-equal",
    "prefix": "fas",
    "className": "fas fa-less-than-equal"
  },
  {
    "name": "level-down-alt",
    "prefix": "fas",
    "className": "fas fa-level-down-alt"
  },
  {
    "name": "level-up-alt",
    "prefix": "fas",
    "className": "fas fa-level-up-alt"
  },
  {
    "name": "life-ring",
    "prefix": "fas",
    "className": "fas fa-life-ring"
  },
  {
    "name": "lightbulb",
    "prefix": "fas",
    "className": "fas fa-lightbulb"
  },
  {
    "name": "line",
    "prefix": "fab",
    "className": "fab fa-line"
  },
  {
    "name": "link",
    "prefix": "fas",
    "className": "fas fa-link"
  },
  {
    "name": "linkedin",
    "prefix": "fab",
    "className": "fab fa-linkedin"
  },
  {
    "name": "linkedin-in",
    "prefix": "fab",
    "className": "fab fa-linkedin-in"
  },
  {
    "name": "linode",
    "prefix": "fab",
    "className": "fab fa-linode"
  },
  {
    "name": "linux",
    "prefix": "fab",
    "className": "fab fa-linux"
  },
  {
    "name": "lira-sign",
    "prefix": "fas",
    "className": "fas fa-lira-sign"
  },
  {
    "name": "list",
    "prefix": "fas",
    "className": "fas fa-list"
  },
  {
    "name": "list-alt",
    "prefix": "fas",
    "className": "fas fa-list-alt"
  },
  {
    "name": "list-ol",
    "prefix": "fas",
    "className": "fas fa-list-ol"
  },
  {
    "name": "list-ul",
    "prefix": "fas",
    "className": "fas fa-list-ul"
  },
  {
    "name": "location-arrow",
    "prefix": "fas",
    "className": "fas fa-location-arrow"
  },
  {
    "name": "lock",
    "prefix": "fas",
    "className": "fas fa-lock"
  },
  {
    "name": "lock-open",
    "prefix": "fas",
    "className": "fas fa-lock-open"
  },
  {
    "name": "long-arrow-alt-down",
    "prefix": "fas",
    "className": "fas fa-long-arrow-alt-down"
  },
  {
    "name": "long-arrow-alt-left",
    "prefix": "fas",
    "className": "fas fa-long-arrow-alt-left"
  },
  {
    "name": "long-arrow-alt-right",
    "prefix": "fas",
    "className": "fas fa-long-arrow-alt-right"
  },
  {
    "name": "long-arrow-alt-up",
    "prefix": "fas",
    "className": "fas fa-long-arrow-alt-up"
  },
  {
    "name": "low-vision",
    "prefix": "fas",
    "className": "fas fa-low-vision"
  },
  {
    "name": "luggage-cart",
    "prefix": "fas",
    "className": "fas fa-luggage-cart"
  },
  {
    "name": "lyft",
    "prefix": "fab",
    "className": "fab fa-lyft"
  },
  {
    "name": "magento",
    "prefix": "fab",
    "className": "fab fa-magento"
  },
  {
    "name": "magic",
    "prefix": "fas",
    "className": "fas fa-magic"
  },
  {
    "name": "magnet",
    "prefix": "fas",
    "className": "fas fa-magnet"
  },
  {
    "name": "mail-bulk",
    "prefix": "fas",
    "className": "fas fa-mail-bulk"
  },
  {
    "name": "mailchimp",
    "prefix": "fab",
    "className": "fab fa-mailchimp"
  },
  {
    "name": "male",
    "prefix": "fas",
    "className": "fas fa-male"
  },
  {
    "name": "mandalorian",
    "prefix": "fab",
    "className": "fab fa-mandalorian"
  },
  {
    "name": "map",
    "prefix": "fas",
    "className": "fas fa-map"
  },
  {
    "name": "map-marked",
    "prefix": "fas",
    "className": "fas fa-map-marked"
  },
  {
    "name": "map-marked-alt",
    "prefix": "fas",
    "className": "fas fa-map-marked-alt"
  },
  {
    "name": "map-marker",
    "prefix": "fas",
    "className": "fas fa-map-marker"
  },
  {
    "name": "map-marker-alt",
    "prefix": "fas",
    "className": "fas fa-map-marker-alt"
  },
  {
    "name": "map-pin",
    "prefix": "fas",
    "className": "fas fa-map-pin"
  },
  {
    "name": "map-signs",
    "prefix": "fas",
    "className": "fas fa-map-signs"
  },
  {
    "name": "markdown",
    "prefix": "fab",
    "className": "fab fa-markdown"
  },
  {
    "name": "marker",
    "prefix": "fas",
    "className": "fas fa-marker"
  },
  {
    "name": "mars",
    "prefix": "fas",
    "className": "fas fa-mars"
  },
  {
    "name": "mars-double",
    "prefix": "fas",
    "className": "fas fa-mars-double"
  },
  {
    "name": "mars-stroke",
    "prefix": "fas",
    "className": "fas fa-mars-stroke"
  },
  {
    "name": "mars-stroke-h",
    "prefix": "fas",
    "className": "fas fa-mars-stroke-h"
  },
  {
    "name": "mars-stroke-v",
    "prefix": "fas",
    "className": "fas fa-mars-stroke-v"
  },
  {
    "name": "mask",
    "prefix": "fas",
    "className": "fas fa-mask"
  },
  {
    "name": "mastodon",
    "prefix": "fab",
    "className": "fab fa-mastodon"
  },
  {
    "name": "maxcdn",
    "prefix": "fab",
    "className": "fab fa-maxcdn"
  },
  {
    "name": "medal",
    "prefix": "fas",
    "className": "fas fa-medal"
  },
  {
    "name": "medapps",
    "prefix": "fab",
    "className": "fab fa-medapps"
  },
  {
    "name": "medium",
    "prefix": "fab",
    "className": "fab fa-medium"
  },
  {
    "name": "medium-m",
    "prefix": "fab",
    "className": "fab fa-medium-m"
  },
  {
    "name": "medkit",
    "prefix": "fas",
    "className": "fas fa-medkit"
  },
  {
    "name": "medrt",
    "prefix": "fab",
    "className": "fab fa-medrt"
  },
  {
    "name": "meetup",
    "prefix": "fab",
    "className": "fab fa-meetup"
  },
  {
    "name": "megaport",
    "prefix": "fab",
    "className": "fab fa-megaport"
  },
  {
    "name": "meh",
    "prefix": "fas",
    "className": "fas fa-meh"
  },
  {
    "name": "meh-blank",
    "prefix": "fas",
    "className": "fas fa-meh-blank"
  },
  {
    "name": "meh-rolling-eyes",
    "prefix": "fas",
    "className": "fas fa-meh-rolling-eyes"
  },
  {
    "name": "memory",
    "prefix": "fas",
    "className": "fas fa-memory"
  },
  {
    "name": "mendeley",
    "prefix": "fab",
    "className": "fab fa-mendeley"
  },
  {
    "name": "menorah",
    "prefix": "fas",
    "className": "fas fa-menorah"
  },
  {
    "name": "mercury",
    "prefix": "fas",
    "className": "fas fa-mercury"
  },
  {
    "name": "meteor",
    "prefix": "fas",
    "className": "fas fa-meteor"
  },
  {
    "name": "microchip",
    "prefix": "fas",
    "className": "fas fa-microchip"
  },
  {
    "name": "microphone",
    "prefix": "fas",
    "className": "fas fa-microphone"
  },
  {
    "name": "microphone-alt",
    "prefix": "fas",
    "className": "fas fa-microphone-alt"
  },
  {
    "name": "microphone-alt-slash",
    "prefix": "fas",
    "className": "fas fa-microphone-alt-slash"
  },
  {
    "name": "microphone-slash",
    "prefix": "fas",
    "className": "fas fa-microphone-slash"
  },
  {
    "name": "microscope",
    "prefix": "fas",
    "className": "fas fa-microscope"
  },
  {
    "name": "microsoft",
    "prefix": "fab",
    "className": "fab fa-microsoft"
  },
  {
    "name": "minus",
    "prefix": "fas",
    "className": "fas fa-minus"
  },
  {
    "name": "minus-circle",
    "prefix": "fas",
    "className": "fas fa-minus-circle"
  },
  {
    "name": "minus-square",
    "prefix": "fas",
    "className": "fas fa-minus-square"
  },
  {
    "name": "mitten",
    "prefix": "fas",
    "className": "fas fa-mitten"
  },
  {
    "name": "mix",
    "prefix": "fab",
    "className": "fab fa-mix"
  },
  {
    "name": "mixcloud",
    "prefix": "fab",
    "className": "fab fa-mixcloud"
  },
  {
    "name": "mizuni",
    "prefix": "fab",
    "className": "fab fa-mizuni"
  },
  {
    "name": "mobile",
    "prefix": "fas",
    "className": "fas fa-mobile"
  },
  {
    "name": "mobile-alt",
    "prefix": "fas",
    "className": "fas fa-mobile-alt"
  },
  {
    "name": "modx",
    "prefix": "fab",
    "className": "fab fa-modx"
  },
  {
    "name": "monero",
    "prefix": "fab",
    "className": "fab fa-monero"
  },
  {
    "name": "money-bill",
    "prefix": "fas",
    "className": "fas fa-money-bill"
  },
  {
    "name": "money-bill-alt",
    "prefix": "fas",
    "className": "fas fa-money-bill-alt"
  },
  {
    "name": "money-bill-wave",
    "prefix": "fas",
    "className": "fas fa-money-bill-wave"
  },
  {
    "name": "money-bill-wave-alt",
    "prefix": "fas",
    "className": "fas fa-money-bill-wave-alt"
  },
  {
    "name": "money-check",
    "prefix": "fas",
    "className": "fas fa-money-check"
  },
  {
    "name": "money-check-alt",
    "prefix": "fas",
    "className": "fas fa-money-check-alt"
  },
  {
    "name": "monument",
    "prefix": "fas",
    "className": "fas fa-monument"
  },
  {
    "name": "moon",
    "prefix": "fas",
    "className": "fas fa-moon"
  },
  {
    "name": "mortar-pestle",
    "prefix": "fas",
    "className": "fas fa-mortar-pestle"
  },
  {
    "name": "mosque",
    "prefix": "fas",
    "className": "fas fa-mosque"
  },
  {
    "name": "motorcycle",
    "prefix": "fas",
    "className": "fas fa-motorcycle"
  },
  {
    "name": "mountain",
    "prefix": "fas",
    "className": "fas fa-mountain"
  },
  {
    "name": "mouse-pointer",
    "prefix": "fas",
    "className": "fas fa-mouse-pointer"
  },
  {
    "name": "mug-hot",
    "prefix": "fas",
    "className": "fas fa-mug-hot"
  },
  {
    "name": "music",
    "prefix": "fas",
    "className": "fas fa-music"
  },
  {
    "name": "napster",
    "prefix": "fab",
    "className": "fab fa-napster"
  },
  {
    "name": "neos",
    "prefix": "fab",
    "className": "fab fa-neos"
  },
  {
    "name": "network-wired",
    "prefix": "fas",
    "className": "fas fa-network-wired"
  },
  {
    "name": "neuter",
    "prefix": "fas",
    "className": "fas fa-neuter"
  },
  {
    "name": "newspaper",
    "prefix": "fas",
    "className": "fas fa-newspaper"
  },
  {
    "name": "nimblr",
    "prefix": "fab",
    "className": "fab fa-nimblr"
  },
  {
    "name": "nintendo-switch",
    "prefix": "fab",
    "className": "fab fa-nintendo-switch"
  },
  {
    "name": "node",
    "prefix": "fab",
    "className": "fab fa-node"
  },
  {
    "name": "node-js",
    "prefix": "fab",
    "className": "fab fa-node-js"
  },
  {
    "name": "not-equal",
    "prefix": "fas",
    "className": "fas fa-not-equal"
  },
  {
    "name": "notes-medical",
    "prefix": "fas",
    "className": "fas fa-notes-medical"
  },
  {
    "name": "npm",
    "prefix": "fab",
    "className": "fab fa-npm"
  },
  {
    "name": "ns8",
    "prefix": "fab",
    "className": "fab fa-ns8"
  },
  {
    "name": "nutritionix",
    "prefix": "fab",
    "className": "fab fa-nutritionix"
  },
  {
    "name": "object-group",
    "prefix": "fas",
    "className": "fas fa-object-group"
  },
  {
    "name": "object-ungroup",
    "prefix": "fas",
    "className": "fas fa-object-ungroup"
  },
  {
    "name": "odnoklassniki",
    "prefix": "fab",
    "className": "fab fa-odnoklassniki"
  },
  {
    "name": "odnoklassniki-square",
    "prefix": "fab",
    "className": "fab fa-odnoklassniki-square"
  },
  {
    "name": "oil-can",
    "prefix": "fas",
    "className": "fas fa-oil-can"
  },
  {
    "name": "old-republic",
    "prefix": "fab",
    "className": "fab fa-old-republic"
  },
  {
    "name": "om",
    "prefix": "fas",
    "className": "fas fa-om"
  },
  {
    "name": "opencart",
    "prefix": "fab",
    "className": "fab fa-opencart"
  },
  {
    "name": "openid",
    "prefix": "fab",
    "className": "fab fa-openid"
  },
  {
    "name": "opera",
    "prefix": "fab",
    "className": "fab fa-opera"
  },
  {
    "name": "optin-monster",
    "prefix": "fab",
    "className": "fab fa-optin-monster"
  },
  {
    "name": "osi",
    "prefix": "fab",
    "className": "fab fa-osi"
  },
  {
    "name": "otter",
    "prefix": "fas",
    "className": "fas fa-otter"
  },
  {
    "name": "outdent",
    "prefix": "fas",
    "className": "fas fa-outdent"
  },
  {
    "name": "page4",
    "prefix": "fab",
    "className": "fab fa-page4"
  },
  {
    "name": "pagelines",
    "prefix": "fab",
    "className": "fab fa-pagelines"
  },
  {
    "name": "paint-brush",
    "prefix": "fas",
    "className": "fas fa-paint-brush"
  },
  {
    "name": "paint-roller",
    "prefix": "fas",
    "className": "fas fa-paint-roller"
  },
  {
    "name": "palette",
    "prefix": "fas",
    "className": "fas fa-palette"
  },
  {
    "name": "palfed",
    "prefix": "fab",
    "className": "fab fa-palfed"
  },
  {
    "name": "pallet",
    "prefix": "fas",
    "className": "fas fa-pallet"
  },
  {
    "name": "paper-plane",
    "prefix": "fas",
    "className": "fas fa-paper-plane"
  },
  {
    "name": "paperclip",
    "prefix": "fas",
    "className": "fas fa-paperclip"
  },
  {
    "name": "parachute-box",
    "prefix": "fas",
    "className": "fas fa-parachute-box"
  },
  {
    "name": "paragraph",
    "prefix": "fas",
    "className": "fas fa-paragraph"
  },
  {
    "name": "parking",
    "prefix": "fas",
    "className": "fas fa-parking"
  },
  {
    "name": "passport",
    "prefix": "fas",
    "className": "fas fa-passport"
  },
  {
    "name": "pastafarianism",
    "prefix": "fas",
    "className": "fas fa-pastafarianism"
  },
  {
    "name": "paste",
    "prefix": "fas",
    "className": "fas fa-paste"
  },
  {
    "name": "patreon",
    "prefix": "fab",
    "className": "fab fa-patreon"
  },
  {
    "name": "pause",
    "prefix": "fas",
    "className": "fas fa-pause"
  },
  {
    "name": "pause-circle",
    "prefix": "fas",
    "className": "fas fa-pause-circle"
  },
  {
    "name": "paw",
    "prefix": "fas",
    "className": "fas fa-paw"
  },
  {
    "name": "paypal",
    "prefix": "fab",
    "className": "fab fa-paypal"
  },
  {
    "name": "peace",
    "prefix": "fas",
    "className": "fas fa-peace"
  },
  {
    "name": "pen",
    "prefix": "fas",
    "className": "fas fa-pen"
  },
  {
    "name": "pen-alt",
    "prefix": "fas",
    "className": "fas fa-pen-alt"
  },
  {
    "name": "pen-fancy",
    "prefix": "fas",
    "className": "fas fa-pen-fancy"
  },
  {
    "name": "pen-nib",
    "prefix": "fas",
    "className": "fas fa-pen-nib"
  },
  {
    "name": "pen-square",
    "prefix": "fas",
    "className": "fas fa-pen-square"
  },
  {
    "name": "pencil-alt",
    "prefix": "fas",
    "className": "fas fa-pencil-alt"
  },
  {
    "name": "pencil-ruler",
    "prefix": "fas",
    "className": "fas fa-pencil-ruler"
  },
  {
    "name": "penny-arcade",
    "prefix": "fab",
    "className": "fab fa-penny-arcade"
  },
  {
    "name": "people-carry",
    "prefix": "fas",
    "className": "fas fa-people-carry"
  },
  {
    "name": "percent",
    "prefix": "fas",
    "className": "fas fa-percent"
  },
  {
    "name": "percentage",
    "prefix": "fas",
    "className": "fas fa-percentage"
  },
  {
    "name": "periscope",
    "prefix": "fab",
    "className": "fab fa-periscope"
  },
  {
    "name": "person-booth",
    "prefix": "fas",
    "className": "fas fa-person-booth"
  },
  {
    "name": "phabricator",
    "prefix": "fab",
    "className": "fab fa-phabricator"
  },
  {
    "name": "phoenix-framework",
    "prefix": "fab",
    "className": "fab fa-phoenix-framework"
  },
  {
    "name": "phoenix-squadron",
    "prefix": "fab",
    "className": "fab fa-phoenix-squadron"
  },
  {
    "name": "phone",
    "prefix": "fas",
    "className": "fas fa-phone"
  },
  {
    "name": "phone-slash",
    "prefix": "fas",
    "className": "fas fa-phone-slash"
  },
  {
    "name": "phone-square",
    "prefix": "fas",
    "className": "fas fa-phone-square"
  },
  {
    "name": "phone-volume",
    "prefix": "fas",
    "className": "fas fa-phone-volume"
  },
  {
    "name": "php",
    "prefix": "fab",
    "className": "fab fa-php"
  },
  {
    "name": "pied-piper",
    "prefix": "fab",
    "className": "fab fa-pied-piper"
  },
  {
    "name": "pied-piper-alt",
    "prefix": "fab",
    "className": "fab fa-pied-piper-alt"
  },
  {
    "name": "pied-piper-hat",
    "prefix": "fab",
    "className": "fab fa-pied-piper-hat"
  },
  {
    "name": "pied-piper-pp",
    "prefix": "fab",
    "className": "fab fa-pied-piper-pp"
  },
  {
    "name": "piggy-bank",
    "prefix": "fas",
    "className": "fas fa-piggy-bank"
  },
  {
    "name": "pills",
    "prefix": "fas",
    "className": "fas fa-pills"
  },
  {
    "name": "pinterest",
    "prefix": "fab",
    "className": "fab fa-pinterest"
  },
  {
    "name": "pinterest-p",
    "prefix": "fab",
    "className": "fab fa-pinterest-p"
  },
  {
    "name": "pinterest-square",
    "prefix": "fab",
    "className": "fab fa-pinterest-square"
  },
  {
    "name": "place-of-worship",
    "prefix": "fas",
    "className": "fas fa-place-of-worship"
  },
  {
    "name": "plane",
    "prefix": "fas",
    "className": "fas fa-plane"
  },
  {
    "name": "plane-arrival",
    "prefix": "fas",
    "className": "fas fa-plane-arrival"
  },
  {
    "name": "plane-departure",
    "prefix": "fas",
    "className": "fas fa-plane-departure"
  },
  {
    "name": "play",
    "prefix": "fas",
    "className": "fas fa-play"
  },
  {
    "name": "play-circle",
    "prefix": "fas",
    "className": "fas fa-play-circle"
  },
  {
    "name": "playstation",
    "prefix": "fab",
    "className": "fab fa-playstation"
  },
  {
    "name": "plug",
    "prefix": "fas",
    "className": "fas fa-plug"
  },
  {
    "name": "plus",
    "prefix": "fas",
    "className": "fas fa-plus"
  },
  {
    "name": "plus-circle",
    "prefix": "fas",
    "className": "fas fa-plus-circle"
  },
  {
    "name": "plus-square",
    "prefix": "fas",
    "className": "fas fa-plus-square"
  },
  {
    "name": "podcast",
    "prefix": "fas",
    "className": "fas fa-podcast"
  },
  {
    "name": "poll",
    "prefix": "fas",
    "className": "fas fa-poll"
  },
  {
    "name": "poll-h",
    "prefix": "fas",
    "className": "fas fa-poll-h"
  },
  {
    "name": "poo",
    "prefix": "fas",
    "className": "fas fa-poo"
  },
  {
    "name": "poo-storm",
    "prefix": "fas",
    "className": "fas fa-poo-storm"
  },
  {
    "name": "poop",
    "prefix": "fas",
    "className": "fas fa-poop"
  },
  {
    "name": "portrait",
    "prefix": "fas",
    "className": "fas fa-portrait"
  },
  {
    "name": "pound-sign",
    "prefix": "fas",
    "className": "fas fa-pound-sign"
  },
  {
    "name": "power-off",
    "prefix": "fas",
    "className": "fas fa-power-off"
  },
  {
    "name": "pray",
    "prefix": "fas",
    "className": "fas fa-pray"
  },
  {
    "name": "praying-hands",
    "prefix": "fas",
    "className": "fas fa-praying-hands"
  },
  {
    "name": "prescription",
    "prefix": "fas",
    "className": "fas fa-prescription"
  },
  {
    "name": "prescription-bottle",
    "prefix": "fas",
    "className": "fas fa-prescription-bottle"
  },
  {
    "name": "prescription-bottle-alt",
    "prefix": "fas",
    "className": "fas fa-prescription-bottle-alt"
  },
  {
    "name": "print",
    "prefix": "fas",
    "className": "fas fa-print"
  },
  {
    "name": "procedures",
    "prefix": "fas",
    "className": "fas fa-procedures"
  },
  {
    "name": "product-hunt",
    "prefix": "fab",
    "className": "fab fa-product-hunt"
  },
  {
    "name": "project-diagram",
    "prefix": "fas",
    "className": "fas fa-project-diagram"
  },
  {
    "name": "pushed",
    "prefix": "fab",
    "className": "fab fa-pushed"
  },
  {
    "name": "puzzle-piece",
    "prefix": "fas",
    "className": "fas fa-puzzle-piece"
  },
  {
    "name": "python",
    "prefix": "fab",
    "className": "fab fa-python"
  },
  {
    "name": "qq",
    "prefix": "fab",
    "className": "fab fa-qq"
  },
  {
    "name": "qrcode",
    "prefix": "fas",
    "className": "fas fa-qrcode"
  },
  {
    "name": "question",
    "prefix": "fas",
    "className": "fas fa-question"
  },
  {
    "name": "question-circle",
    "prefix": "fas",
    "className": "fas fa-question-circle"
  },
  {
    "name": "quidditch",
    "prefix": "fas",
    "className": "fas fa-quidditch"
  },
  {
    "name": "quinscape",
    "prefix": "fab",
    "className": "fab fa-quinscape"
  },
  {
    "name": "quora",
    "prefix": "fab",
    "className": "fab fa-quora"
  },
  {
    "name": "quote-left",
    "prefix": "fas",
    "className": "fas fa-quote-left"
  },
  {
    "name": "quote-right",
    "prefix": "fas",
    "className": "fas fa-quote-right"
  },
  {
    "name": "quran",
    "prefix": "fas",
    "className": "fas fa-quran"
  },
  {
    "name": "r-project",
    "prefix": "fab",
    "className": "fab fa-r-project"
  },
  {
    "name": "radiation",
    "prefix": "fas",
    "className": "fas fa-radiation"
  },
  {
    "name": "radiation-alt",
    "prefix": "fas",
    "className": "fas fa-radiation-alt"
  },
  {
    "name": "rainbow",
    "prefix": "fas",
    "className": "fas fa-rainbow"
  },
  {
    "name": "random",
    "prefix": "fas",
    "className": "fas fa-random"
  },
  {
    "name": "raspberry-pi",
    "prefix": "fab",
    "className": "fab fa-raspberry-pi"
  },
  {
    "name": "ravelry",
    "prefix": "fab",
    "className": "fab fa-ravelry"
  },
  {
    "name": "react",
    "prefix": "fab",
    "className": "fab fa-react"
  },
  {
    "name": "reacteurope",
    "prefix": "fab",
    "className": "fab fa-reacteurope"
  },
  {
    "name": "readme",
    "prefix": "fab",
    "className": "fab fa-readme"
  },
  {
    "name": "rebel",
    "prefix": "fab",
    "className": "fab fa-rebel"
  },
  {
    "name": "receipt",
    "prefix": "fas",
    "className": "fas fa-receipt"
  },
  {
    "name": "recycle",
    "prefix": "fas",
    "className": "fas fa-recycle"
  },
  {
    "name": "red-river",
    "prefix": "fab",
    "className": "fab fa-red-river"
  },
  {
    "name": "reddit",
    "prefix": "fab",
    "className": "fab fa-reddit"
  },
  {
    "name": "reddit-alien",
    "prefix": "fab",
    "className": "fab fa-reddit-alien"
  },
  {
    "name": "reddit-square",
    "prefix": "fab",
    "className": "fab fa-reddit-square"
  },
  {
    "name": "redhat",
    "prefix": "fab",
    "className": "fab fa-redhat"
  },
  {
    "name": "redo",
    "prefix": "fas",
    "className": "fas fa-redo"
  },
  {
    "name": "redo-alt",
    "prefix": "fas",
    "className": "fas fa-redo-alt"
  },
  {
    "name": "registered",
    "prefix": "fas",
    "className": "fas fa-registered"
  },
  {
    "name": "renren",
    "prefix": "fab",
    "className": "fab fa-renren"
  },
  {
    "name": "reply",
    "prefix": "fas",
    "className": "fas fa-reply"
  },
  {
    "name": "reply-all",
    "prefix": "fas",
    "className": "fas fa-reply-all"
  },
  {
    "name": "replyd",
    "prefix": "fab",
    "className": "fab fa-replyd"
  },
  {
    "name": "republican",
    "prefix": "fas",
    "className": "fas fa-republican"
  },
  {
    "name": "researchgate",
    "prefix": "fab",
    "className": "fab fa-researchgate"
  },
  {
    "name": "resolving",
    "prefix": "fab",
    "className": "fab fa-resolving"
  },
  {
    "name": "restroom",
    "prefix": "fas",
    "className": "fas fa-restroom"
  },
  {
    "name": "retweet",
    "prefix": "fas",
    "className": "fas fa-retweet"
  },
  {
    "name": "rev",
    "prefix": "fab",
    "className": "fab fa-rev"
  },
  {
    "name": "ribbon",
    "prefix": "fas",
    "className": "fas fa-ribbon"
  },
  {
    "name": "ring",
    "prefix": "fas",
    "className": "fas fa-ring"
  },
  {
    "name": "road",
    "prefix": "fas",
    "className": "fas fa-road"
  },
  {
    "name": "robot",
    "prefix": "fas",
    "className": "fas fa-robot"
  },
  {
    "name": "rocket",
    "prefix": "fas",
    "className": "fas fa-rocket"
  },
  {
    "name": "rocketchat",
    "prefix": "fab",
    "className": "fab fa-rocketchat"
  },
  {
    "name": "rockrms",
    "prefix": "fab",
    "className": "fab fa-rockrms"
  },
  {
    "name": "route",
    "prefix": "fas",
    "className": "fas fa-route"
  },
  {
    "name": "rss",
    "prefix": "fas",
    "className": "fas fa-rss"
  },
  {
    "name": "rss-square",
    "prefix": "fas",
    "className": "fas fa-rss-square"
  },
  {
    "name": "ruble-sign",
    "prefix": "fas",
    "className": "fas fa-ruble-sign"
  },
  {
    "name": "ruler",
    "prefix": "fas",
    "className": "fas fa-ruler"
  },
  {
    "name": "ruler-combined",
    "prefix": "fas",
    "className": "fas fa-ruler-combined"
  },
  {
    "name": "ruler-horizontal",
    "prefix": "fas",
    "className": "fas fa-ruler-horizontal"
  },
  {
    "name": "ruler-vertical",
    "prefix": "fas",
    "className": "fas fa-ruler-vertical"
  },
  {
    "name": "running",
    "prefix": "fas",
    "className": "fas fa-running"
  },
  {
    "name": "rupee-sign",
    "prefix": "fas",
    "className": "fas fa-rupee-sign"
  },
  {
    "name": "sad-cry",
    "prefix": "fas",
    "className": "fas fa-sad-cry"
  },
  {
    "name": "sad-tear",
    "prefix": "fas",
    "className": "fas fa-sad-tear"
  },
  {
    "name": "safari",
    "prefix": "fab",
    "className": "fab fa-safari"
  },
  {
    "name": "sass",
    "prefix": "fab",
    "className": "fab fa-sass"
  },
  {
    "name": "satellite",
    "prefix": "fas",
    "className": "fas fa-satellite"
  },
  {
    "name": "satellite-dish",
    "prefix": "fas",
    "className": "fas fa-satellite-dish"
  },
  {
    "name": "save",
    "prefix": "fas",
    "className": "fas fa-save"
  },
  {
    "name": "schlix",
    "prefix": "fab",
    "className": "fab fa-schlix"
  },
  {
    "name": "school",
    "prefix": "fas",
    "className": "fas fa-school"
  },
  {
    "name": "screwdriver",
    "prefix": "fas",
    "className": "fas fa-screwdriver"
  },
  {
    "name": "scribd",
    "prefix": "fab",
    "className": "fab fa-scribd"
  },
  {
    "name": "scroll",
    "prefix": "fas",
    "className": "fas fa-scroll"
  },
  {
    "name": "sd-card",
    "prefix": "fas",
    "className": "fas fa-sd-card"
  },
  {
    "name": "search",
    "prefix": "fas",
    "className": "fas fa-search"
  },
  {
    "name": "search-dollar",
    "prefix": "fas",
    "className": "fas fa-search-dollar"
  },
  {
    "name": "search-location",
    "prefix": "fas",
    "className": "fas fa-search-location"
  },
  {
    "name": "search-minus",
    "prefix": "fas",
    "className": "fas fa-search-minus"
  },
  {
    "name": "search-plus",
    "prefix": "fas",
    "className": "fas fa-search-plus"
  },
  {
    "name": "searchengin",
    "prefix": "fab",
    "className": "fab fa-searchengin"
  },
  {
    "name": "seedling",
    "prefix": "fas",
    "className": "fas fa-seedling"
  },
  {
    "name": "sellcast",
    "prefix": "fab",
    "className": "fab fa-sellcast"
  },
  {
    "name": "sellsy",
    "prefix": "fab",
    "className": "fab fa-sellsy"
  },
  {
    "name": "server",
    "prefix": "fas",
    "className": "fas fa-server"
  },
  {
    "name": "servicestack",
    "prefix": "fab",
    "className": "fab fa-servicestack"
  },
  {
    "name": "shapes",
    "prefix": "fas",
    "className": "fas fa-shapes"
  },
  {
    "name": "share",
    "prefix": "fas",
    "className": "fas fa-share"
  },
  {
    "name": "share-alt",
    "prefix": "fas",
    "className": "fas fa-share-alt"
  },
  {
    "name": "share-alt-square",
    "prefix": "fas",
    "className": "fas fa-share-alt-square"
  },
  {
    "name": "share-square",
    "prefix": "fas",
    "className": "fas fa-share-square"
  },
  {
    "name": "shekel-sign",
    "prefix": "fas",
    "className": "fas fa-shekel-sign"
  },
  {
    "name": "shield-alt",
    "prefix": "fas",
    "className": "fas fa-shield-alt"
  },
  {
    "name": "ship",
    "prefix": "fas",
    "className": "fas fa-ship"
  },
  {
    "name": "shipping-fast",
    "prefix": "fas",
    "className": "fas fa-shipping-fast"
  },
  {
    "name": "shirtsinbulk",
    "prefix": "fab",
    "className": "fab fa-shirtsinbulk"
  },
  {
    "name": "shoe-prints",
    "prefix": "fas",
    "className": "fas fa-shoe-prints"
  },
  {
    "name": "shopping-bag",
    "prefix": "fas",
    "className": "fas fa-shopping-bag"
  },
  {
    "name": "shopping-basket",
    "prefix": "fas",
    "className": "fas fa-shopping-basket"
  },
  {
    "name": "shopping-cart",
    "prefix": "fas",
    "className": "fas fa-shopping-cart"
  },
  {
    "name": "shopware",
    "prefix": "fab",
    "className": "fab fa-shopware"
  },
  {
    "name": "shower",
    "prefix": "fas",
    "className": "fas fa-shower"
  },
  {
    "name": "shuttle-van",
    "prefix": "fas",
    "className": "fas fa-shuttle-van"
  },
  {
    "name": "sign",
    "prefix": "fas",
    "className": "fas fa-sign"
  },
  {
    "name": "sign-in-alt",
    "prefix": "fas",
    "className": "fas fa-sign-in-alt"
  },
  {
    "name": "sign-language",
    "prefix": "fas",
    "className": "fas fa-sign-language"
  },
  {
    "name": "sign-out-alt",
    "prefix": "fas",
    "className": "fas fa-sign-out-alt"
  },
  {
    "name": "signal",
    "prefix": "fas",
    "className": "fas fa-signal"
  },
  {
    "name": "signature",
    "prefix": "fas",
    "className": "fas fa-signature"
  },
  {
    "name": "sim-card",
    "prefix": "fas",
    "className": "fas fa-sim-card"
  },
  {
    "name": "simplybuilt",
    "prefix": "fab",
    "className": "fab fa-simplybuilt"
  },
  {
    "name": "sistrix",
    "prefix": "fab",
    "className": "fab fa-sistrix"
  },
  {
    "name": "sitemap",
    "prefix": "fas",
    "className": "fas fa-sitemap"
  },
  {
    "name": "sith",
    "prefix": "fab",
    "className": "fab fa-sith"
  },
  {
    "name": "skating",
    "prefix": "fas",
    "className": "fas fa-skating"
  },
  {
    "name": "sketch",
    "prefix": "fab",
    "className": "fab fa-sketch"
  },
  {
    "name": "skiing",
    "prefix": "fas",
    "className": "fas fa-skiing"
  },
  {
    "name": "skiing-nordic",
    "prefix": "fas",
    "className": "fas fa-skiing-nordic"
  },
  {
    "name": "skull",
    "prefix": "fas",
    "className": "fas fa-skull"
  },
  {
    "name": "skull-crossbones",
    "prefix": "fas",
    "className": "fas fa-skull-crossbones"
  },
  {
    "name": "skyatlas",
    "prefix": "fab",
    "className": "fab fa-skyatlas"
  },
  {
    "name": "skype",
    "prefix": "fab",
    "className": "fab fa-skype"
  },
  {
    "name": "slack",
    "prefix": "fab",
    "className": "fab fa-slack"
  },
  {
    "name": "slack-hash",
    "prefix": "fab",
    "className": "fab fa-slack-hash"
  },
  {
    "name": "slash",
    "prefix": "fas",
    "className": "fas fa-slash"
  },
  {
    "name": "sleigh",
    "prefix": "fas",
    "className": "fas fa-sleigh"
  },
  {
    "name": "sliders-h",
    "prefix": "fas",
    "className": "fas fa-sliders-h"
  },
  {
    "name": "slideshare",
    "prefix": "fab",
    "className": "fab fa-slideshare"
  },
  {
    "name": "smile",
    "prefix": "fas",
    "className": "fas fa-smile"
  },
  {
    "name": "smile-beam",
    "prefix": "fas",
    "className": "fas fa-smile-beam"
  },
  {
    "name": "smile-wink",
    "prefix": "fas",
    "className": "fas fa-smile-wink"
  },
  {
    "name": "smog",
    "prefix": "fas",
    "className": "fas fa-smog"
  },
  {
    "name": "smoking",
    "prefix": "fas",
    "className": "fas fa-smoking"
  },
  {
    "name": "smoking-ban",
    "prefix": "fas",
    "className": "fas fa-smoking-ban"
  },
  {
    "name": "sms",
    "prefix": "fas",
    "className": "fas fa-sms"
  },
  {
    "name": "snapchat",
    "prefix": "fab",
    "className": "fab fa-snapchat"
  },
  {
    "name": "snapchat-ghost",
    "prefix": "fab",
    "className": "fab fa-snapchat-ghost"
  },
  {
    "name": "snapchat-square",
    "prefix": "fab",
    "className": "fab fa-snapchat-square"
  },
  {
    "name": "snowboarding",
    "prefix": "fas",
    "className": "fas fa-snowboarding"
  },
  {
    "name": "snowflake",
    "prefix": "fas",
    "className": "fas fa-snowflake"
  },
  {
    "name": "snowman",
    "prefix": "fas",
    "className": "fas fa-snowman"
  },
  {
    "name": "snowplow",
    "prefix": "fas",
    "className": "fas fa-snowplow"
  },
  {
    "name": "socks",
    "prefix": "fas",
    "className": "fas fa-socks"
  },
  {
    "name": "solar-panel",
    "prefix": "fas",
    "className": "fas fa-solar-panel"
  },
  {
    "name": "sort",
    "prefix": "fas",
    "className": "fas fa-sort"
  },
  {
    "name": "sort-alpha-down",
    "prefix": "fas",
    "className": "fas fa-sort-alpha-down"
  },
  {
    "name": "sort-alpha-up",
    "prefix": "fas",
    "className": "fas fa-sort-alpha-up"
  },
  {
    "name": "sort-amount-down",
    "prefix": "fas",
    "className": "fas fa-sort-amount-down"
  },
  {
    "name": "sort-amount-up",
    "prefix": "fas",
    "className": "fas fa-sort-amount-up"
  },
  {
    "name": "sort-down",
    "prefix": "fas",
    "className": "fas fa-sort-down"
  },
  {
    "name": "sort-numeric-down",
    "prefix": "fas",
    "className": "fas fa-sort-numeric-down"
  },
  {
    "name": "sort-numeric-up",
    "prefix": "fas",
    "className": "fas fa-sort-numeric-up"
  },
  {
    "name": "sort-up",
    "prefix": "fas",
    "className": "fas fa-sort-up"
  },
  {
    "name": "soundcloud",
    "prefix": "fab",
    "className": "fab fa-soundcloud"
  },
  {
    "name": "sourcetree",
    "prefix": "fab",
    "className": "fab fa-sourcetree"
  },
  {
    "name": "spa",
    "prefix": "fas",
    "className": "fas fa-spa"
  },
  {
    "name": "space-shuttle",
    "prefix": "fas",
    "className": "fas fa-space-shuttle"
  },
  {
    "name": "speakap",
    "prefix": "fab",
    "className": "fab fa-speakap"
  },
  {
    "name": "spider",
    "prefix": "fas",
    "className": "fas fa-spider"
  },
  {
    "name": "spinner",
    "prefix": "fas",
    "className": "fas fa-spinner"
  },
  {
    "name": "splotch",
    "prefix": "fas",
    "className": "fas fa-splotch"
  },
  {
    "name": "spotify",
    "prefix": "fab",
    "className": "fab fa-spotify"
  },
  {
    "name": "spray-can",
    "prefix": "fas",
    "className": "fas fa-spray-can"
  },
  {
    "name": "square",
    "prefix": "fas",
    "className": "fas fa-square"
  },
  {
    "name": "square-full",
    "prefix": "fas",
    "className": "fas fa-square-full"
  },
  {
    "name": "square-root-alt",
    "prefix": "fas",
    "className": "fas fa-square-root-alt"
  },
  {
    "name": "squarespace",
    "prefix": "fab",
    "className": "fab fa-squarespace"
  },
  {
    "name": "stack-exchange",
    "prefix": "fab",
    "className": "fab fa-stack-exchange"
  },
  {
    "name": "stack-overflow",
    "prefix": "fab",
    "className": "fab fa-stack-overflow"
  },
  {
    "name": "stamp",
    "prefix": "fas",
    "className": "fas fa-stamp"
  },
  {
    "name": "star",
    "prefix": "fas",
    "className": "fas fa-star"
  },
  {
    "name": "star-and-crescent",
    "prefix": "fas",
    "className": "fas fa-star-and-crescent"
  },
  {
    "name": "star-half",
    "prefix": "fas",
    "className": "fas fa-star-half"
  },
  {
    "name": "star-half-alt",
    "prefix": "fas",
    "className": "fas fa-star-half-alt"
  },
  {
    "name": "star-of-david",
    "prefix": "fas",
    "className": "fas fa-star-of-david"
  },
  {
    "name": "star-of-life",
    "prefix": "fas",
    "className": "fas fa-star-of-life"
  },
  {
    "name": "staylinked",
    "prefix": "fab",
    "className": "fab fa-staylinked"
  },
  {
    "name": "steam",
    "prefix": "fab",
    "className": "fab fa-steam"
  },
  {
    "name": "steam-square",
    "prefix": "fab",
    "className": "fab fa-steam-square"
  },
  {
    "name": "steam-symbol",
    "prefix": "fab",
    "className": "fab fa-steam-symbol"
  },
  {
    "name": "step-backward",
    "prefix": "fas",
    "className": "fas fa-step-backward"
  },
  {
    "name": "step-forward",
    "prefix": "fas",
    "className": "fas fa-step-forward"
  },
  {
    "name": "stethoscope",
    "prefix": "fas",
    "className": "fas fa-stethoscope"
  },
  {
    "name": "sticker-mule",
    "prefix": "fab",
    "className": "fab fa-sticker-mule"
  },
  {
    "name": "sticky-note",
    "prefix": "fas",
    "className": "fas fa-sticky-note"
  },
  {
    "name": "stop",
    "prefix": "fas",
    "className": "fas fa-stop"
  },
  {
    "name": "stop-circle",
    "prefix": "fas",
    "className": "fas fa-stop-circle"
  },
  {
    "name": "stopwatch",
    "prefix": "fas",
    "className": "fas fa-stopwatch"
  },
  {
    "name": "store",
    "prefix": "fas",
    "className": "fas fa-store"
  },
  {
    "name": "store-alt",
    "prefix": "fas",
    "className": "fas fa-store-alt"
  },
  {
    "name": "strava",
    "prefix": "fab",
    "className": "fab fa-strava"
  },
  {
    "name": "stream",
    "prefix": "fas",
    "className": "fas fa-stream"
  },
  {
    "name": "street-view",
    "prefix": "fas",
    "className": "fas fa-street-view"
  },
  {
    "name": "strikethrough",
    "prefix": "fas",
    "className": "fas fa-strikethrough"
  },
  {
    "name": "stripe",
    "prefix": "fab",
    "className": "fab fa-stripe"
  },
  {
    "name": "stripe-s",
    "prefix": "fab",
    "className": "fab fa-stripe-s"
  },
  {
    "name": "stroopwafel",
    "prefix": "fas",
    "className": "fas fa-stroopwafel"
  },
  {
    "name": "studiovinari",
    "prefix": "fab",
    "className": "fab fa-studiovinari"
  },
  {
    "name": "stumbleupon",
    "prefix": "fab",
    "className": "fab fa-stumbleupon"
  },
  {
    "name": "stumbleupon-circle",
    "prefix": "fab",
    "className": "fab fa-stumbleupon-circle"
  },
  {
    "name": "subscript",
    "prefix": "fas",
    "className": "fas fa-subscript"
  },
  {
    "name": "subway",
    "prefix": "fas",
    "className": "fas fa-subway"
  },
  {
    "name": "suitcase",
    "prefix": "fas",
    "className": "fas fa-suitcase"
  },
  {
    "name": "suitcase-rolling",
    "prefix": "fas",
    "className": "fas fa-suitcase-rolling"
  },
  {
    "name": "sun",
    "prefix": "fas",
    "className": "fas fa-sun"
  },
  {
    "name": "superpowers",
    "prefix": "fab",
    "className": "fab fa-superpowers"
  },
  {
    "name": "superscript",
    "prefix": "fas",
    "className": "fas fa-superscript"
  },
  {
    "name": "supple",
    "prefix": "fab",
    "className": "fab fa-supple"
  },
  {
    "name": "surprise",
    "prefix": "fas",
    "className": "fas fa-surprise"
  },
  {
    "name": "suse",
    "prefix": "fab",
    "className": "fab fa-suse"
  },
  {
    "name": "swatchbook",
    "prefix": "fas",
    "className": "fas fa-swatchbook"
  },
  {
    "name": "swimmer",
    "prefix": "fas",
    "className": "fas fa-swimmer"
  },
  {
    "name": "swimming-pool",
    "prefix": "fas",
    "className": "fas fa-swimming-pool"
  },
  {
    "name": "synagogue",
    "prefix": "fas",
    "className": "fas fa-synagogue"
  },
  {
    "name": "sync",
    "prefix": "fas",
    "className": "fas fa-sync"
  },
  {
    "name": "sync-alt",
    "prefix": "fas",
    "className": "fas fa-sync-alt"
  },
  {
    "name": "syringe",
    "prefix": "fas",
    "className": "fas fa-syringe"
  },
  {
    "name": "table",
    "prefix": "fas",
    "className": "fas fa-table"
  },
  {
    "name": "table-tennis",
    "prefix": "fas",
    "className": "fas fa-table-tennis"
  },
  {
    "name": "tablet",
    "prefix": "fas",
    "className": "fas fa-tablet"
  },
  {
    "name": "tablet-alt",
    "prefix": "fas",
    "className": "fas fa-tablet-alt"
  },
  {
    "name": "tablets",
    "prefix": "fas",
    "className": "fas fa-tablets"
  },
  {
    "name": "tachometer-alt",
    "prefix": "fas",
    "className": "fas fa-tachometer-alt"
  },
  {
    "name": "tag",
    "prefix": "fas",
    "className": "fas fa-tag"
  },
  {
    "name": "tags",
    "prefix": "fas",
    "className": "fas fa-tags"
  },
  {
    "name": "tape",
    "prefix": "fas",
    "className": "fas fa-tape"
  },
  {
    "name": "tasks",
    "prefix": "fas",
    "className": "fas fa-tasks"
  },
  {
    "name": "taxi",
    "prefix": "fas",
    "className": "fas fa-taxi"
  },
  {
    "name": "teamspeak",
    "prefix": "fab",
    "className": "fab fa-teamspeak"
  },
  {
    "name": "teeth",
    "prefix": "fas",
    "className": "fas fa-teeth"
  },
  {
    "name": "teeth-open",
    "prefix": "fas",
    "className": "fas fa-teeth-open"
  },
  {
    "name": "telegram",
    "prefix": "fab",
    "className": "fab fa-telegram"
  },
  {
    "name": "telegram-plane",
    "prefix": "fab",
    "className": "fab fa-telegram-plane"
  },
  {
    "name": "temperature-high",
    "prefix": "fas",
    "className": "fas fa-temperature-high"
  },
  {
    "name": "temperature-low",
    "prefix": "fas",
    "className": "fas fa-temperature-low"
  },
  {
    "name": "tencent-weibo",
    "prefix": "fab",
    "className": "fab fa-tencent-weibo"
  },
  {
    "name": "tenge",
    "prefix": "fas",
    "className": "fas fa-tenge"
  },
  {
    "name": "terminal",
    "prefix": "fas",
    "className": "fas fa-terminal"
  },
  {
    "name": "text-height",
    "prefix": "fas",
    "className": "fas fa-text-height"
  },
  {
    "name": "text-width",
    "prefix": "fas",
    "className": "fas fa-text-width"
  },
  {
    "name": "th",
    "prefix": "fas",
    "className": "fas fa-th"
  },
  {
    "name": "th-large",
    "prefix": "fas",
    "className": "fas fa-th-large"
  },
  {
    "name": "th-list",
    "prefix": "fas",
    "className": "fas fa-th-list"
  },
  {
    "name": "the-red-yeti",
    "prefix": "fab",
    "className": "fab fa-the-red-yeti"
  },
  {
    "name": "theater-masks",
    "prefix": "fas",
    "className": "fas fa-theater-masks"
  },
  {
    "name": "themeco",
    "prefix": "fab",
    "className": "fab fa-themeco"
  },
  {
    "name": "themeisle",
    "prefix": "fab",
    "className": "fab fa-themeisle"
  },
  {
    "name": "thermometer",
    "prefix": "fas",
    "className": "fas fa-thermometer"
  },
  {
    "name": "thermometer-empty",
    "prefix": "fas",
    "className": "fas fa-thermometer-empty"
  },
  {
    "name": "thermometer-full",
    "prefix": "fas",
    "className": "fas fa-thermometer-full"
  },
  {
    "name": "thermometer-half",
    "prefix": "fas",
    "className": "fas fa-thermometer-half"
  },
  {
    "name": "thermometer-quarter",
    "prefix": "fas",
    "className": "fas fa-thermometer-quarter"
  },
  {
    "name": "thermometer-three-quarters",
    "prefix": "fas",
    "className": "fas fa-thermometer-three-quarters"
  },
  {
    "name": "think-peaks",
    "prefix": "fab",
    "className": "fab fa-think-peaks"
  },
  {
    "name": "thumbs-down",
    "prefix": "fas",
    "className": "fas fa-thumbs-down"
  },
  {
    "name": "thumbs-up",
    "prefix": "fas",
    "className": "fas fa-thumbs-up"
  },
  {
    "name": "thumbtack",
    "prefix": "fas",
    "className": "fas fa-thumbtack"
  },
  {
    "name": "ticket-alt",
    "prefix": "fas",
    "className": "fas fa-ticket-alt"
  },
  {
    "name": "times",
    "prefix": "fas",
    "className": "fas fa-times"
  },
  {
    "name": "times-circle",
    "prefix": "fas",
    "className": "fas fa-times-circle"
  },
  {
    "name": "tint",
    "prefix": "fas",
    "className": "fas fa-tint"
  },
  {
    "name": "tint-slash",
    "prefix": "fas",
    "className": "fas fa-tint-slash"
  },
  {
    "name": "tired",
    "prefix": "fas",
    "className": "fas fa-tired"
  },
  {
    "name": "toggle-off",
    "prefix": "fas",
    "className": "fas fa-toggle-off"
  },
  {
    "name": "toggle-on",
    "prefix": "fas",
    "className": "fas fa-toggle-on"
  },
  {
    "name": "toilet",
    "prefix": "fas",
    "className": "fas fa-toilet"
  },
  {
    "name": "toilet-paper",
    "prefix": "fas",
    "className": "fas fa-toilet-paper"
  },
  {
    "name": "toolbox",
    "prefix": "fas",
    "className": "fas fa-toolbox"
  },
  {
    "name": "tools",
    "prefix": "fas",
    "className": "fas fa-tools"
  },
  {
    "name": "tooth",
    "prefix": "fas",
    "className": "fas fa-tooth"
  },
  {
    "name": "torah",
    "prefix": "fas",
    "className": "fas fa-torah"
  },
  {
    "name": "torii-gate",
    "prefix": "fas",
    "className": "fas fa-torii-gate"
  },
  {
    "name": "tractor",
    "prefix": "fas",
    "className": "fas fa-tractor"
  },
  {
    "name": "trade-federation",
    "prefix": "fab",
    "className": "fab fa-trade-federation"
  },
  {
    "name": "trademark",
    "prefix": "fas",
    "className": "fas fa-trademark"
  },
  {
    "name": "traffic-light",
    "prefix": "fas",
    "className": "fas fa-traffic-light"
  },
  {
    "name": "train",
    "prefix": "fas",
    "className": "fas fa-train"
  },
  {
    "name": "tram",
    "prefix": "fas",
    "className": "fas fa-tram"
  },
  {
    "name": "transgender",
    "prefix": "fas",
    "className": "fas fa-transgender"
  },
  {
    "name": "transgender-alt",
    "prefix": "fas",
    "className": "fas fa-transgender-alt"
  },
  {
    "name": "trash",
    "prefix": "fas",
    "className": "fas fa-trash"
  },
  {
    "name": "trash-alt",
    "prefix": "fas",
    "className": "fas fa-trash-alt"
  },
  {
    "name": "tree",
    "prefix": "fas",
    "className": "fas fa-tree"
  },
  {
    "name": "trello",
    "prefix": "fab",
    "className": "fab fa-trello"
  },
  {
    "name": "tripadvisor",
    "prefix": "fab",
    "className": "fab fa-tripadvisor"
  },
  {
    "name": "trophy",
    "prefix": "fas",
    "className": "fas fa-trophy"
  },
  {
    "name": "truck",
    "prefix": "fas",
    "className": "fas fa-truck"
  },
  {
    "name": "truck-loading",
    "prefix": "fas",
    "className": "fas fa-truck-loading"
  },
  {
    "name": "truck-monster",
    "prefix": "fas",
    "className": "fas fa-truck-monster"
  },
  {
    "name": "truck-moving",
    "prefix": "fas",
    "className": "fas fa-truck-moving"
  },
  {
    "name": "truck-pickup",
    "prefix": "fas",
    "className": "fas fa-truck-pickup"
  },
  {
    "name": "tshirt",
    "prefix": "fas",
    "className": "fas fa-tshirt"
  },
  {
    "name": "tty",
    "prefix": "fas",
    "className": "fas fa-tty"
  },
  {
    "name": "tumblr",
    "prefix": "fab",
    "className": "fab fa-tumblr"
  },
  {
    "name": "tumblr-square",
    "prefix": "fab",
    "className": "fab fa-tumblr-square"
  },
  {
    "name": "tv",
    "prefix": "fas",
    "className": "fas fa-tv"
  },
  {
    "name": "twitch",
    "prefix": "fab",
    "className": "fab fa-twitch"
  },
  {
    "name": "twitter",
    "prefix": "fab",
    "className": "fab fa-twitter"
  },
  {
    "name": "twitter-square",
    "prefix": "fab",
    "className": "fab fa-twitter-square"
  },
  {
    "name": "typo3",
    "prefix": "fab",
    "className": "fab fa-typo3"
  },
  {
    "name": "uber",
    "prefix": "fab",
    "className": "fab fa-uber"
  },
  {
    "name": "ubuntu",
    "prefix": "fab",
    "className": "fab fa-ubuntu"
  },
  {
    "name": "uikit",
    "prefix": "fab",
    "className": "fab fa-uikit"
  },
  {
    "name": "umbrella",
    "prefix": "fas",
    "className": "fas fa-umbrella"
  },
  {
    "name": "umbrella-beach",
    "prefix": "fas",
    "className": "fas fa-umbrella-beach"
  },
  {
    "name": "underline",
    "prefix": "fas",
    "className": "fas fa-underline"
  },
  {
    "name": "undo",
    "prefix": "fas",
    "className": "fas fa-undo"
  },
  {
    "name": "undo-alt",
    "prefix": "fas",
    "className": "fas fa-undo-alt"
  },
  {
    "name": "uniregistry",
    "prefix": "fab",
    "className": "fab fa-uniregistry"
  },
  {
    "name": "universal-access",
    "prefix": "fas",
    "className": "fas fa-universal-access"
  },
  {
    "name": "university",
    "prefix": "fas",
    "className": "fas fa-university"
  },
  {
    "name": "unlink",
    "prefix": "fas",
    "className": "fas fa-unlink"
  },
  {
    "name": "unlock",
    "prefix": "fas",
    "className": "fas fa-unlock"
  },
  {
    "name": "unlock-alt",
    "prefix": "fas",
    "className": "fas fa-unlock-alt"
  },
  {
    "name": "untappd",
    "prefix": "fab",
    "className": "fab fa-untappd"
  },
  {
    "name": "upload",
    "prefix": "fas",
    "className": "fas fa-upload"
  },
  {
    "name": "ups",
    "prefix": "fab",
    "className": "fab fa-ups"
  },
  {
    "name": "usb",
    "prefix": "fab",
    "className": "fab fa-usb"
  },
  {
    "name": "user",
    "prefix": "fas",
    "className": "fas fa-user"
  },
  {
    "name": "user-alt",
    "prefix": "fas",
    "className": "fas fa-user-alt"
  },
  {
    "name": "user-alt-slash",
    "prefix": "fas",
    "className": "fas fa-user-alt-slash"
  },
  {
    "name": "user-astronaut",
    "prefix": "fas",
    "className": "fas fa-user-astronaut"
  },
  {
    "name": "user-check",
    "prefix": "fas",
    "className": "fas fa-user-check"
  },
  {
    "name": "user-circle",
    "prefix": "fas",
    "className": "fas fa-user-circle"
  },
  {
    "name": "user-clock",
    "prefix": "fas",
    "className": "fas fa-user-clock"
  },
  {
    "name": "user-cog",
    "prefix": "fas",
    "className": "fas fa-user-cog"
  },
  {
    "name": "user-edit",
    "prefix": "fas",
    "className": "fas fa-user-edit"
  },
  {
    "name": "user-friends",
    "prefix": "fas",
    "className": "fas fa-user-friends"
  },
  {
    "name": "user-graduate",
    "prefix": "fas",
    "className": "fas fa-user-graduate"
  },
  {
    "name": "user-injured",
    "prefix": "fas",
    "className": "fas fa-user-injured"
  },
  {
    "name": "user-lock",
    "prefix": "fas",
    "className": "fas fa-user-lock"
  },
  {
    "name": "user-md",
    "prefix": "fas",
    "className": "fas fa-user-md"
  },
  {
    "name": "user-minus",
    "prefix": "fas",
    "className": "fas fa-user-minus"
  },
  {
    "name": "user-ninja",
    "prefix": "fas",
    "className": "fas fa-user-ninja"
  },
  {
    "name": "user-plus",
    "prefix": "fas",
    "className": "fas fa-user-plus"
  },
  {
    "name": "user-secret",
    "prefix": "fas",
    "className": "fas fa-user-secret"
  },
  {
    "name": "user-shield",
    "prefix": "fas",
    "className": "fas fa-user-shield"
  },
  {
    "name": "user-slash",
    "prefix": "fas",
    "className": "fas fa-user-slash"
  },
  {
    "name": "user-tag",
    "prefix": "fas",
    "className": "fas fa-user-tag"
  },
  {
    "name": "user-tie",
    "prefix": "fas",
    "className": "fas fa-user-tie"
  },
  {
    "name": "user-times",
    "prefix": "fas",
    "className": "fas fa-user-times"
  },
  {
    "name": "users",
    "prefix": "fas",
    "className": "fas fa-users"
  },
  {
    "name": "users-cog",
    "prefix": "fas",
    "className": "fas fa-users-cog"
  },
  {
    "name": "usps",
    "prefix": "fab",
    "className": "fab fa-usps"
  },
  {
    "name": "ussunnah",
    "prefix": "fab",
    "className": "fab fa-ussunnah"
  },
  {
    "name": "utensil-spoon",
    "prefix": "fas",
    "className": "fas fa-utensil-spoon"
  },
  {
    "name": "utensils",
    "prefix": "fas",
    "className": "fas fa-utensils"
  },
  {
    "name": "vaadin",
    "prefix": "fab",
    "className": "fab fa-vaadin"
  },
  {
    "name": "vector-square",
    "prefix": "fas",
    "className": "fas fa-vector-square"
  },
  {
    "name": "venus",
    "prefix": "fas",
    "className": "fas fa-venus"
  },
  {
    "name": "venus-double",
    "prefix": "fas",
    "className": "fas fa-venus-double"
  },
  {
    "name": "venus-mars",
    "prefix": "fas",
    "className": "fas fa-venus-mars"
  },
  {
    "name": "viacoin",
    "prefix": "fab",
    "className": "fab fa-viacoin"
  },
  {
    "name": "viadeo",
    "prefix": "fab",
    "className": "fab fa-viadeo"
  },
  {
    "name": "viadeo-square",
    "prefix": "fab",
    "className": "fab fa-viadeo-square"
  },
  {
    "name": "vial",
    "prefix": "fas",
    "className": "fas fa-vial"
  },
  {
    "name": "vials",
    "prefix": "fas",
    "className": "fas fa-vials"
  },
  {
    "name": "viber",
    "prefix": "fab",
    "className": "fab fa-viber"
  },
  {
    "name": "video",
    "prefix": "fas",
    "className": "fas fa-video"
  },
  {
    "name": "video-slash",
    "prefix": "fas",
    "className": "fas fa-video-slash"
  },
  {
    "name": "vihara",
    "prefix": "fas",
    "className": "fas fa-vihara"
  },
  {
    "name": "vimeo",
    "prefix": "fab",
    "className": "fab fa-vimeo"
  },
  {
    "name": "vimeo-square",
    "prefix": "fab",
    "className": "fab fa-vimeo-square"
  },
  {
    "name": "vimeo-v",
    "prefix": "fab",
    "className": "fab fa-vimeo-v"
  },
  {
    "name": "vine",
    "prefix": "fab",
    "className": "fab fa-vine"
  },
  {
    "name": "vk",
    "prefix": "fab",
    "className": "fab fa-vk"
  },
  {
    "name": "vnv",
    "prefix": "fab",
    "className": "fab fa-vnv"
  },
  {
    "name": "volleyball-ball",
    "prefix": "fas",
    "className": "fas fa-volleyball-ball"
  },
  {
    "name": "volume-down",
    "prefix": "fas",
    "className": "fas fa-volume-down"
  },
  {
    "name": "volume-mute",
    "prefix": "fas",
    "className": "fas fa-volume-mute"
  },
  {
    "name": "volume-off",
    "prefix": "fas",
    "className": "fas fa-volume-off"
  },
  {
    "name": "volume-up",
    "prefix": "fas",
    "className": "fas fa-volume-up"
  },
  {
    "name": "vote-yea",
    "prefix": "fas",
    "className": "fas fa-vote-yea"
  },
  {
    "name": "vr-cardboard",
    "prefix": "fas",
    "className": "fas fa-vr-cardboard"
  },
  {
    "name": "vuejs",
    "prefix": "fab",
    "className": "fab fa-vuejs"
  },
  {
    "name": "walking",
    "prefix": "fas",
    "className": "fas fa-walking"
  },
  {
    "name": "wallet",
    "prefix": "fas",
    "className": "fas fa-wallet"
  },
  {
    "name": "warehouse",
    "prefix": "fas",
    "className": "fas fa-warehouse"
  },
  {
    "name": "water",
    "prefix": "fas",
    "className": "fas fa-water"
  },
  {
    "name": "weebly",
    "prefix": "fab",
    "className": "fab fa-weebly"
  },
  {
    "name": "weibo",
    "prefix": "fab",
    "className": "fab fa-weibo"
  },
  {
    "name": "weight",
    "prefix": "fas",
    "className": "fas fa-weight"
  },
  {
    "name": "weight-hanging",
    "prefix": "fas",
    "className": "fas fa-weight-hanging"
  },
  {
    "name": "weixin",
    "prefix": "fab",
    "className": "fab fa-weixin"
  },
  {
    "name": "whatsapp",
    "prefix": "fab",
    "className": "fab fa-whatsapp"
  },
  {
    "name": "whatsapp-square",
    "prefix": "fab",
    "className": "fab fa-whatsapp-square"
  },
  {
    "name": "wheelchair",
    "prefix": "fas",
    "className": "fas fa-wheelchair"
  },
  {
    "name": "whmcs",
    "prefix": "fab",
    "className": "fab fa-whmcs"
  },
  {
    "name": "wifi",
    "prefix": "fas",
    "className": "fas fa-wifi"
  },
  {
    "name": "wikipedia-w",
    "prefix": "fab",
    "className": "fab fa-wikipedia-w"
  },
  {
    "name": "wind",
    "prefix": "fas",
    "className": "fas fa-wind"
  },
  {
    "name": "window-close",
    "prefix": "fas",
    "className": "fas fa-window-close"
  },
  {
    "name": "window-maximize",
    "prefix": "fas",
    "className": "fas fa-window-maximize"
  },
  {
    "name": "window-minimize",
    "prefix": "fas",
    "className": "fas fa-window-minimize"
  },
  {
    "name": "window-restore",
    "prefix": "fas",
    "className": "fas fa-window-restore"
  },
  {
    "name": "windows",
    "prefix": "fab",
    "className": "fab fa-windows"
  },
  {
    "name": "wine-bottle",
    "prefix": "fas",
    "className": "fas fa-wine-bottle"
  },
  {
    "name": "wine-glass",
    "prefix": "fas",
    "className": "fas fa-wine-glass"
  },
  {
    "name": "wine-glass-alt",
    "prefix": "fas",
    "className": "fas fa-wine-glass-alt"
  },
  {
    "name": "wix",
    "prefix": "fab",
    "className": "fab fa-wix"
  },
  {
    "name": "wizards-of-the-coast",
    "prefix": "fab",
    "className": "fab fa-wizards-of-the-coast"
  },
  {
    "name": "wolf-pack-battalion",
    "prefix": "fab",
    "className": "fab fa-wolf-pack-battalion"
  },
  {
    "name": "won-sign",
    "prefix": "fas",
    "className": "fas fa-won-sign"
  },
  {
    "name": "wordpress",
    "prefix": "fab",
    "className": "fab fa-wordpress"
  },
  {
    "name": "wordpress-simple",
    "prefix": "fab",
    "className": "fab fa-wordpress-simple"
  },
  {
    "name": "wpbeginner",
    "prefix": "fab",
    "className": "fab fa-wpbeginner"
  },
  {
    "name": "wpexplorer",
    "prefix": "fab",
    "className": "fab fa-wpexplorer"
  },
  {
    "name": "wpforms",
    "prefix": "fab",
    "className": "fab fa-wpforms"
  },
  {
    "name": "wpressr",
    "prefix": "fab",
    "className": "fab fa-wpressr"
  },
  {
    "name": "wrench",
    "prefix": "fas",
    "className": "fas fa-wrench"
  },
  {
    "name": "x-ray",
    "prefix": "fas",
    "className": "fas fa-x-ray"
  },
  {
    "name": "xbox",
    "prefix": "fab",
    "className": "fab fa-xbox"
  },
  {
    "name": "xing",
    "prefix": "fab",
    "className": "fab fa-xing"
  },
  {
    "name": "xing-square",
    "prefix": "fab",
    "className": "fab fa-xing-square"
  },
  {
    "name": "y-combinator",
    "prefix": "fab",
    "className": "fab fa-y-combinator"
  },
  {
    "name": "yahoo",
    "prefix": "fab",
    "className": "fab fa-yahoo"
  },
  {
    "name": "yandex",
    "prefix": "fab",
    "className": "fab fa-yandex"
  },
  {
    "name": "yandex-international",
    "prefix": "fab",
    "className": "fab fa-yandex-international"
  },
  {
    "name": "yarn",
    "prefix": "fab",
    "className": "fab fa-yarn"
  },
  {
    "name": "yelp",
    "prefix": "fab",
    "className": "fab fa-yelp"
  },
  {
    "name": "yen-sign",
    "prefix": "fas",
    "className": "fas fa-yen-sign"
  },
  {
    "name": "yin-yang",
    "prefix": "fas",
    "className": "fas fa-yin-yang"
  },
  {
    "name": "yoast",
    "prefix": "fab",
    "className": "fab fa-yoast"
  },
  {
    "name": "youtube",
    "prefix": "fab",
    "className": "fab fa-youtube"
  },
  {
    "name": "youtube-square",
    "prefix": "fab",
    "className": "fab fa-youtube-square"
  },
  {
    "name": "zhihu",
    "prefix": "fab",
    "className": "fab fa-zhihu"
  }
]

export default {
  name: 'icons',
  components: {
    BaseHeader,
    RouteBreadcrumb,
  },
  data() {
    return {
      search: '',
      niIcons: NI_ICONS,
      noIcons: NO_ICONS,
      faIcons: FA_ICONS,
    }
  },
  computed: {
    query() {
      return String(this.search || '')
        .trim()
        .toLowerCase()
    },
    filteredNi() {
      if (!this.query) return this.niIcons
      return this.niIcons.filter((name) => name.toLowerCase().includes(this.query))
    },
    filteredNo() {
      if (!this.query) return this.noIcons
      return this.noIcons.filter((name) => name.toLowerCase().includes(this.query))
    },
    filteredFa() {
      if (!this.query) return this.faIcons
      return this.faIcons.filter(
        (icon) =>
          icon.name.includes(this.query) ||
          icon.className.toLowerCase().includes(this.query)
      )
    },
  },
  methods: {
    onCopy() {
      this.$notify({
        type: 'info',
        message: 'Copied to clipboard',
      })
    },
  },
}
</script>
<style></style>
